// import React, { useState } from 'react';
// import { ChevronLeft, Home, Zap, ShoppingCart, User, CheckCircle, XCircle } from 'lucide-react';

// // Mock product data based on the images
// const product = {
//     title: 'ES-BOX12, 5.12kWh, 51.2V, 100Ah',
//     image: 'https://placehold.co/400x350/E0F0FF/3b82f6?text=ES-BOX12+Solar+Inverter',
//     price: '1,232,460.71 NGN',
//     features: [
//         'Two mounting methods: Removable floor stand and wall mount',
//         'Wifi remote monitoring and cloud management service',
//         '6,000 cycles at 80% DOD',
//         '1C continual charge and discharge',
//         '10+ years standard design life',
//         'Superior LiFePO4 safety performance',
//         'Max. 16 modules in parallel',
//     ],
//     loadCapacity: 'Max Output: 5.0 kW',
//     powerRating: '51.2V, 100Ah',
// };

// // Reusable list item for product features
// const FeatureItem = ({ text }) => (
//     <li className="flex items-start mb-1.5 text-gray-700">
//         <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
//         <span className="text-sm">{text}</span>
//     </li>
// );

// // Reusable section for product details
// const DetailSection = ({ title, children }) => (
//     <div className="py-4 border-b border-gray-200">
//         <h2 className="text-sm font-bold text-gray-500 tracking-wider mb-2">{title}</h2>
//         {children}
//     </div>
// );

// // Main Application Component
// const ProductView = ({onBack}) => {
//     const [bookInstallation, setBookInstallation] = useState(false);

//     const handleAddToCart = () => {
//         // In a real application, this would dispatch an action or navigate
//         console.log('Adding product to cart:', product.title);
//     };

//     return (
//         <div className="min-h-screen bg-gray-100 p-4 sm:p-0">
//             {/* Mobile Container Mockup */}
//             <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl sm:rounded-none">

//                 {/* Header */}
//                 <header className="flex items-center p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
//                     <button className="text-gray-600 hover:text-blue-500 transition" onClick={onBack}>
//                         <ChevronLeft className="w-6 h-6" />
//                     </button>
//                     <h1 className="flex-grow text-center text-lg font-semibold text-gray-800">Product Detail</h1>
//                     {/* Placeholder for symmetry */}
//                     <div className="w-6 h-6"></div> 
//                 </header>

//                 {/* Scrollable Content Area */}
//                 <main className="flex-grow overflow-y-auto">

//                     {/* Product Image Card */}
//                     <div className="p-4 bg-white">
//                         <div className="bg-gray-100 rounded-xl overflow-hidden shadow-sm">
//                             <img 
//                                 src={product.image} 
//                                 alt={product.title} 
//                                 className="w-full h-auto object-cover rounded-xl"
//                                 onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/400x350/E0F0FF/3b82f6?text=Image+Unavailable"; }}
//                             />
//                         </div>
//                     </div>

//                     {/* Product Details Card */}
//                     <div className="p-5 bg-white space-y-4">
//                         <h1 className="text-xl font-bold text-gray-900">{product.title}</h1>

//                         {/* Product Price */}
//                         <DetailSection title="PRODUCT PRICE">
//                             <p className="text-2xl font-extrabold text-blue-600">{product.price}</p>
//                         </DetailSection>

//                         {/* Product Features */}
//                         <DetailSection title="PRODUCT FEATURE">
//                             <ul className="list-none p-0 m-0">
//                                 {product.features.map((feature, index) => (
//                                     <FeatureItem key={index} text={feature} />
//                                 ))}
//                             </ul>
//                         </DetailSection>

//                         {/* Load Capacity */}
//                         <DetailSection title="LOAD CAPACITY">
//                             <p className="text-base text-gray-700 font-medium">{product.loadCapacity}</p>
//                         </DetailSection>

//                         {/* Power Rating (No border-bottom for the last standard section) */}
//                         <div className="py-4">
//                             <h2 className="text-sm font-bold text-gray-500 tracking-wider mb-2">POWER RATING</h2>
//                             <p className="text-base text-gray-700 font-medium">{product.powerRating}</p>
//                         </div>
//                     </div>

//                     {/* Book Installation Toggle Section - Styled as a distinct card/row */}
//                     <div className="mt-4 p-5 bg-white border-t border-b border-gray-200 flex items-center justify-between shadow-sm">
//                         <h2 className="text-lg font-semibold text-gray-800">Book Installation</h2>

//                         {/* Custom Toggle Switch */}
//                         <label className="relative inline-flex items-center cursor-pointer">
//                             <input 
//                                 type="checkbox" 
//                                 className="sr-only peer" 
//                                 checked={bookInstallation} 
//                                 onChange={() => setBookInstallation(!bookInstallation)}
//                             />
//                             <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
//                         </label>
//                     </div>

//                 </main>

//                 {/* Fixed Footer Action and Navigation */}
//                 <div className="sticky bottom-0 bg-white z-20 shadow-lg">
//                     {/* Add to Cart Button */}
//                     <div className="p-4 border-t border-gray-100">
//                         <button 
//                             onClick={handleAddToCart}
//                             className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-600 transition duration-200"
//                         >
//                             Add to cart
//                         </button>
//                     </div>

//                     {/* Navigation Bar */}
//                     <nav className="border-t border-gray-200 py-2.5">
//                         <div className="flex justify-around items-center h-16">
//                             {/* Home */}
//                             <a href="#" className="flex flex-col items-center text-gray-400 hover:text-blue-500 transition duration-150">
//                                 <Home className="w-6 h-6" />
//                                 <span className="text-xs mt-0.5">Home</span>
//                             </a>
//                             {/* Energy */}
//                             <a href="#" className="flex flex-col items-center text-gray-400 hover:text-blue-500 transition duration-150">
//                                 <Zap className="w-6 h-6" />
//                                 <span className="text-xs mt-0.5">Energy</span>
//                             </a>
//                             {/* Cart (Active in this context) */}
//                             <a href="#" className="flex flex-col items-center text-blue-500 transition duration-150">
//                                 <ShoppingCart className="w-6 h-6" />
//                                 <span className="text-xs mt-0.5">Cart</span>
//                             </a>
//                             {/* Profile */}
//                             <a href="#" className="flex flex-col items-center text-gray-400 hover:text-blue-500 transition duration-150">
//                                 <User className="w-6 h-6" />
//                                 <span className="text-xs mt-0.5">Profile</span>
//                             </a>
//                         </div>
//                         {/* Indicator line */}
//                         <div className="h-1 w-24 mx-auto bg-gray-300 rounded-full mt-1"></div>
//                     </nav>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ProductView;

// import React, { useState, useMemo } from 'react';
// import { ChevronLeft, Home, Zap, ShoppingCart, User, CheckCircle, XCircle, ShoppingBag, Minus, Plus, Trash2 } from 'lucide-react';

// // --- MOCK DATA ---
// const product = {
//     id: 'esbox12',
//     title: 'ES-BOX12, 5.12kWh, 51.2V, 100Ah',
//     image: 'https://placehold.co/400x350/E0F0FF/3b82f6?text=ES-BOX12+Solar+Battery',
//     unitPrice: 1232460.71, // Numerical price for calculation
//     displayPrice: '1,232,460.71 NGN', // Formatted price for display
//     features: [
//         'Two mounting methods: Removable floor stand and wall mount',
//         'Wifi remote monitoring and cloud management service',
//         '6,000 cycles at 80% DOD',
//         '1C continual charge and discharge',
//         '10+ years standard design life',
//         'Superior LiFePO4 safety performance',
//         'Max. 16 modules in parallel',
//     ],
//     loadCapacity: 'Max Output: 5.0 kW',
//     powerRating: '51.2V, 100Ah',
// };

// // --- HELPER COMPONENTS ---

// // Reusable list item for product features
// const FeatureItem = ({ text }) => (
//     <li className="flex items-start mb-1.5 text-gray-700">
//         <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
//         <span className="text-sm">{text}</span>
//     </li>
// );

// // Reusable section for product details
// const DetailSection = ({ title, children }) => (
//     <div className="py-4 border-b border-gray-200">
//         <h2 className="text-sm font-bold text-gray-500 tracking-wider mb-2">{title}</h2>
//         {children}
//     </div>
// );

// // Reusable function to format currency, matching the image's format (no currency symbol, commas for thousands, period for decimals)
// const formatPrice = (price) => {
//     // Format to match the image style: 1232460.71
//     return new Intl.NumberFormat('en-US', {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//     }).format(price);
// };

// // Header Component
// const Header = ({ title, onBack }) => (
//     <header className="flex items-center p-4 border-b border-gray-200 sticky top-0 bg-white z-20">
//         <button className="text-gray-600 hover:text-blue-500 transition" onClick={onBack}>
//             <ChevronLeft className="w-6 h-6" />
//         </button>
//         <h1 className="flex-grow text-center text-lg font-semibold text-gray-800">{title}</h1>
//         {/* Placeholder for symmetry */}
//         <div className="w-6 h-6"></div> 
//     </header>
// );

// // Removed NavBar component

// // Success Modal Component
// const SuccessModal = ({ productTitle, onClose, onGoToCart }) => {
//     return (
//         <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-60 transition-opacity duration-300 backdrop-blur-sm">
//             <div className="bg-white w-full max-w-md p-6 rounded-t-3xl shadow-2xl animate-slideUp">

//                 {/* Close Button */}
//                 <button 
//                     onClick={onClose} 
//                     className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
//                 >
//                     <XCircle className="w-7 h-7" />
//                 </button>

//                 <div className="flex flex-col items-center text-center space-y-4">
//                     {/* Success Icon */}
//                     <div className="p-4 bg-green-100 rounded-full">
//                         <ShoppingBag className="w-8 h-8 text-green-600" />
//                     </div>

//                     <h2 className="text-xl font-bold text-gray-900">Added to Cart!</h2>

//                     <p className="text-sm text-gray-600">
//                         <span className="font-semibold text-blue-600">{productTitle}</span> has been successfully added to your shopping cart.
//                     </p>

//                     {/* Actions */}
//                     <div className="w-full space-y-3 pt-4">
//                         <button 
//                             onClick={onGoToCart}
//                             className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200"
//                         >
//                             View Cart
//                         </button>
//                         <button 
//                             onClick={onClose}
//                             className="w-full bg-white text-blue-600 border border-blue-600 py-3 rounded-xl font-semibold text-lg hover:bg-blue-50 transition duration-200"
//                         >
//                             Continue Shopping
//                         </button>
//                     </div>
//                 </div>
//             </div>
//             {/* Custom Animation Style */}
//             <style jsx="true">{`
//                 @keyframes slideUp {
//                     from { transform: translateY(100%); }
//                     to { transform: translateY(0); }
//                 }
//                 .animate-slideUp {
//                     animation: slideUp 0.3s ease-out forwards;
//                 }
//             `}</style>
//         </div>
//     );
// };

// // --- 1. PRODUCT VIEW COMPONENT ---

// const ProductViews = ({ onAddToCart, onViewChange }) => {
//     const [bookInstallation, setBookInstallation] = useState(false);
//     const [showSuccessModal, setShowSuccessModal] = useState(false); // State for the modal

//     const handleAddToCart = () => {
//         onAddToCart(product);
//         setShowSuccessModal(true); // Show the success modal
//     };

//     // When user clicks 'Continue Shopping' in the modal or the 'X' close button
//     const handleCloseModal = () => {
//         setShowSuccessModal(false);
//         // Stays on the product view screen
//         onViewChange('product'); 
//     };

//     // When user clicks 'View Cart' in the modal
//     const handleGoToCart = () => {
//         setShowSuccessModal(false);
//         // Navigates to the Checkout view
//         onViewChange('checkout'); 
//     };

//     return (
//         <div className="">
//             <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl sm:rounded-none relative">

//                 {/* Header */}
//                 <Header title="Product Detail" onBack={() => onViewChange('home')} />

//                 {/* Scrollable Content Area */}
//                 <main className="flex-grow overflow-y-auto">

//                     {/* Product Image Card */}
//                     <div className="p-4 bg-white">
//                         <div className="bg-gray-100 rounded-xl overflow-hidden shadow-sm">
//                             <img 
//                                 src={product.image} 
//                                 alt={product.title} 
//                                 className="w-full h-auto object-cover rounded-xl"
//                                 onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/400x350/E0F0FF/3b82f6?text=Image+Unavailable"; }}
//                             />
//                         </div>
//                     </div>

//                     {/* Product Details Card */}
//                     <div className="p-5 bg-white space-y-4">
//                         <h1 className="text-xl font-bold text-gray-900">{product.title}</h1>

//                         {/* Product Price */}
//                         <DetailSection title="PRODUCT PRICE">
//                             <p className="text-2xl font-extrabold text-blue-600">{product.displayPrice}</p>
//                         </DetailSection>

//                         {/* Product Features */}
//                         <DetailSection title="PRODUCT FEATURE">
//                             <ul className="list-none p-0 m-0">
//                                 {product.features.map((feature, index) => (
//                                     <FeatureItem key={index} text={feature} />
//                                 ))}
//                             </ul>
//                         </DetailSection>

//                         {/* Load Capacity */}
//                         <DetailSection title="LOAD CAPACITY">
//                             <p className="text-base text-gray-700 font-medium">{product.loadCapacity}</p>
//                         </DetailSection>

//                         {/* Power Rating (No border-bottom for the last standard section) */}
//                         <div className="py-4">
//                             <h2 className="text-sm font-bold text-gray-500 tracking-wider mb-2">POWER RATING</h2>
//                             <p className="text-base text-gray-700 font-medium">{product.powerRating}</p>
//                         </div>
//                     </div>

//                     {/* Book Installation Toggle Section - Styled as a distinct card/row */}
//                     <div className="mt-4 p-5 bg-white border-t border-b border-gray-200 flex items-center justify-between shadow-sm">
//                         <h2 className="text-lg font-semibold text-gray-800">Book Installation</h2>

//                         {/* Custom Toggle Switch */}
//                         <label className="relative inline-flex items-center cursor-pointer">
//                             <input 
//                                 type="checkbox" 
//                                 className="sr-only peer" 
//                                 checked={bookInstallation} 
//                                 onChange={() => setBookInstallation(!bookInstallation)}
//                             />
//                             <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
//                         </label>
//                     </div>

//                 </main>

//                 {/* Fixed Footer Action */}
//                 <div className="sticky bottom-0 bg-white z-20 shadow-lg">
//                     {/* Add to Cart Button */}
//                     <div className="p-4 border-t border-gray-100">
//                         <button 
//                             onClick={handleAddToCart}
//                             className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-600 transition duration-200 active:scale-[0.99]"
//                         >
//                             Add to cart
//                         </button>
//                     </div>
//                     {/* Removed NavBar */}
//                 </div>
//             </div>

//             {showSuccessModal && (
//                 <SuccessModal 
//                     productTitle={product.title} 
//                     onClose={handleCloseModal} 
//                     onGoToCart={handleGoToCart}
//                 />
//             )}
//         </div>
//     );
// };

// // --- 2. CHECKOUT VIEW COMPONENT (REPLICATING THE IMAGE) ---

// const CheckoutItem = ({ item, onUpdateQuantity, onRemove }) => {
//     // Determine the product name line content
//     const productNameLine = `${item.title.split(',')[0]}, ${item.title.split(',')[1].trim()}, ${item.title.split(',')[2].trim()}`;

//     return (
//         <div className="flex justify-between items-start py-3 border-b border-gray-100">
//             <div className="flex flex-grow items-start space-x-3">
//                 <img 
//                     src={item.image} 
//                     alt={item.title} 
//                     className="w-12 h-12 object-cover rounded-lg flex-shrink-0"
//                     onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/48x48/E0F0FF/3b82f6?text=Item"; }}
//                 />
//                 <div className="flex-grow">
//                     {/* Product Title is wrapped/displayed on one line in the image, showing key specs */}
//                     <p className="text-sm text-gray-900 font-medium leading-tight mb-1">{productNameLine}</p>
//                     {/* Price in the next line */}
//                     <p className="text-base font-bold text-gray-900">
//                         NGN {formatPrice(item.unitPrice)}
//                     </p>
//                 </div>
//             </div>

//             <div className="flex flex-col items-end space-y-1 ml-4">
//                 {/* Remove button */}
//                 <button 
//                     onClick={() => onRemove(item.id)} 
//                     className="text-xs font-medium text-blue-600 hover:text-blue-700 transition self-end"
//                 >
//                     Remove
//                 </button>

//                 {/* Quantity Controls - styled as in the image */}
//                 <div className="flex items-center border border-gray-300 rounded-md mt-1">
//                     {/* Minus Button */}
//                     <button 
//                         onClick={() => onUpdateQuantity(item.id, item.quantity - 1)} 
//                         disabled={item.quantity <= 1}
//                         className="px-2 py-1 text-gray-500 disabled:text-gray-300 hover:bg-gray-100 transition rounded-l-md"
//                     >
//                         <Minus className="w-3 h-3" />
//                     </button>
//                     {/* Quantity Display */}
//                     <span className="px-1 text-sm font-medium text-gray-700">
//                         {item.quantity}
//                     </span>
//                     {/* Plus Button */}
//                     <button 
//                         onClick={() => onUpdateQuantity(item.id, item.quantity + 1)} 
//                         className="px-2 py-1 text-gray-500 hover:bg-gray-100 transition rounded-r-md"
//                     >
//                         <Plus className="w-3 h-3" />
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const CheckoutView = ({ cartItems, setCartItems, onViewChange }) => {

//     // --- Cart Logic ---
//     const handleUpdateQuantity = (id, newQuantity) => {
//         if (newQuantity < 1) return; // Prevent quantity below 1
//         setCartItems(prevItems => 
//             prevItems.map(item => item.id === id ? { ...item, quantity: newQuantity } : item)
//         );
//     };

//     const handleRemoveItem = (id) => {
//         setCartItems(prevItems => prevItems.filter(item => item.id !== id));
//     };


//     const cartCalculations = useMemo(() => {
//         const total = cartItems.reduce((sum, item) => sum + (item.unitPrice * item.quantity), 0);
//         return { total };
//     }, [cartItems]);

//     // Check for empty cart
//     if (cartItems.length === 0) {
//         return (
//             <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl sm:rounded-none relative">
//                 <Header title="Checkout" onBack={() => onViewChange('product')} />
//                 <div className="flex-grow flex flex-col items-center justify-center p-8 text-center">
//                     <ShoppingCart className="w-16 h-16 text-gray-300 mb-4" />
//                     <h2 className="text-xl font-semibold text-gray-700 mb-2">Your Cart is Empty</h2>
//                     <p className="text-gray-500 mb-6">Start shopping to proceed to checkout.</p>
//                     <button 
//                         onClick={() => onViewChange('product')}
//                         className="bg-blue-600 text-white py-2 px-6 rounded-xl font-semibold shadow-md hover:bg-blue-700 transition"
//                     >
//                         Start Shopping
//                     </button>
//                 </div>
//             </div>
//         );
//     }

//     const { total } = cartCalculations;

//     return (
//         <div className="min-h-screen bg-gray-100 p-4 sm:p-0 font-inter">
//             <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl sm:rounded-none relative">

//                 {/* Header - Title 'Checkout' matches the image top bar */}
//                 <Header title="Checkout" onBack={() => onViewChange('product')} />

//                 {/* Scrollable Content Area */}
//                 <main className="flex-grow overflow-y-auto p-4">

//                     {/* Main Title 'Your cart items' */}
//                     <h2 className="text-xl font-bold text-gray-900 mb-4 text-center">Your cart items</h2>

//                     {/* Back to Shopping link - Calls onViewChange('product') */}
//                     <button 
//                         onClick={() => onViewChange('product')}
//                         className="text-blue-600 font-semibold text-sm block mx-auto mb-6 hover:underline"
//                     >
//                         Back to shopping
//                     </button>

//                     {/* Table Header Row (simplified for mobile) */}
//                     <div className="flex justify-between border-b border-gray-300 pb-2 mb-2 px-2">
//                         <span className="text-xs uppercase font-bold text-gray-500 w-1/2">Product</span>
//                         <span className="text-xs uppercase font-bold text-gray-500 w-1/2 text-right">Price/Quantity</span>
//                     </div>

//                     {/* Cart Items List */}
//                     <div className="space-y-4">
//                         {cartItems.map(item => (
//                             <CheckoutItem 
//                                 key={item.id} 
//                                 item={item} 
//                                 onUpdateQuantity={handleUpdateQuantity}
//                                 onRemove={handleRemoveItem} 
//                             />
//                         ))}
//                     </div>

//                 </main>

//                 {/* Fixed Footer Total and Pay Now Button (Matching Image) */}
//                 <div className="sticky bottom-0 bg-white z-20 shadow-lg border-t border-gray-200">
//                     <div className="flex justify-between items-center p-4">
//                         <div className="flex flex-col">
//                             <span className="text-xs text-gray-500">Total price</span>
//                             {/* Total price exactly as in the image */}
//                             <p className="text-lg font-bold text-blue-600">
//                                 {formatPrice(total)} NGN 
//                             </p>
//                         </div>

//                         {/* Pay Now Button */}
//                         <button 
//                             onClick={() => console.log('Initiating Payment...')}
//                             className="bg-blue-600 text-white py-3 px-8 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200"
//                         >
//                             Pay Now
//                         </button>
//                     </div>

//                     {/* Removed NavBar */}
//                 </div>
//             </div>
//         </div>
//     );
// };


// // --- 3. MAIN APP COMPONENT ---

// const ProductView = () => {
//     // State to manage the current view: 'product', 'checkout', or 'home'
//     const [view, setView] = useState('product'); 

//     // State to manage cart items
//     const [cartItems, setCartItems] = useState([{ ...product, quantity: 1 }]); 

//     const handleAddToCart = (productToAdd) => {
//         setCartItems(prevItems => {
//             const existingItem = prevItems.find(item => item.id === productToAdd.id);
//             if (existingItem) {
//                 // If item exists, increase quantity
//                 return prevItems.map(item => 
//                     item.id === productToAdd.id ? { ...item, quantity: item.quantity + 1 } : item
//                 );
//             } else {
//                 // Otherwise, add new item
//                 return [...prevItems, { ...productToAdd, quantity: 1 }];
//             }
//         });
//     };

//     const handleViewChange = (newView) => {
//         if (newView === 'home') {
//             alert('Navigating to Home/Catalog. Staying on current View for demonstration.');
//             // We ensure we land back on product view if home is clicked, for this demo
//             setView('product'); 
//         } else {
//             setView(newView);
//         }
//     }

//     // Render the appropriate component based on the current view state
//     let CurrentScreen;
//     if (view === 'checkout') {
//         CurrentScreen = <CheckoutView 
//                             cartItems={cartItems} 
//                             setCartItems={setCartItems}
//                             onViewChange={handleViewChange}
//                         />;
//     } else {
//         // Defaults to 'product' or 'home'
//         CurrentScreen = <ProductViews 
//                             onAddToCart={handleAddToCart}
//                             onViewChange={handleViewChange}
//                         />;
//     }

//     return (
//         <div className="min-h-screen">
//             {/* Tailwind CSS Setup */}
//             <script src="https://cdn.tailwindcss.com"></script>
//             <style>
//                 {`
//                 @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
//                 .font-inter { font-family: 'Inter', sans-serif; }
//                 .max-w-md { max-width: 420px; } /* Typical large mobile width */
//                 `}
//             </style>

//             {CurrentScreen}

//             {/* The main application is assumed to render the Navbar here */}
//             {/* <NavBar activeView={view} onViewChange={handleViewChange} /> */}

//         </div>
//     );
// };

// export default ProductView;



import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { Phone,Mail,Loader2, AlertTriangle, X, Download, MapPin, ChevronLeft, Home, Zap, ShoppingCart, User, CheckCircle, XCircle, ShoppingBag, Minus, Plus, Trash2, Check, WifiOff } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { InterswitchPay } from 'react-interswitch';
import { useProductBackHandler } from '../../hooks/productbackhandler';
import { API_BASE_URL } from '../../config/api';




// --- MOCK DATA ---
// const product = {
//     id: 'esbox12',
//     title: 'ES-BOX12, 5.12kWh, 51.2V, 100Ah',
//     image: 'https://placehold.co/400x350/E0F0FF/3b82f6?text=ES-BOX12+Solar+Battery',
//     unitPrice: 1232460.71, // Numerical price for calculation
//     displayPrice: '1,232,460.71 NGN', // Formatted price for display
//     features: [
//         'Two mounting methods: Removable floor stand and wall mount',
//         'Wifi remote monitoring and cloud management service',
//         '6,000 cycles at 80% DOD',
//         '1C continual charge and discharge',
//         '10+ years standard design life',
//         'Superior LiFePO4 safety performance',
//         'Max. 16 modules in parallel',
//     ],
//     loadCapacity: 'Max Output: 5.0 kW',
//     powerRating: '51.2V, 100Ah',
// };

// --- HELPER COMPONENTS ---

const FeatureItem = ({ text }) => (
    <li className="flex items-start mb-1.5 text-gray-700">
        <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
        <span className="text-sm">{text}</span>
    </li>
);

const DetailSection = ({ title, children }) => (
    <div className="py-4 border-b border-gray-200">
        <h2 className="text-sm font-bold text-gray-500 tracking-wider mb-2">{title}</h2>
        {children}
    </div>
);

const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(price);
};

// Header Component
const Header = ({ title, onBack }) => (
    // Removed 'sticky top-0' and ensured z-index for fixed stacking
    <header className="flex items-center p-4 border-b border-gray-200 bg-white z-20 w-full max-w-md mx-auto">
        {title !== 'Order Receipt' && (<button
            className="text-gray-600 hover:text-blue-500 transition p-1 -ml-1"
            onClick={onBack}
            aria-label={`Go back to ${title === 'Product Detail' ? 'Marketplace' : 'Product Detail'}`}
        >
            <ChevronLeft className="w-6 h-6" />
        </button>)}
        <h1 className="flex-grow text-center text-lg font-semibold text-gray-800 mr-4">{title}</h1>
    </header>
    // const Header = ({ title, onBack }) => (
    // <header className="sticky top-0 z-10 bg-white border-b border-gray-200 shadow-sm">
    //     <div className="p-4 flex items-center justify-start">
    //         <button
    //             onClick={onBack}
    //             className="p-2 text-gray-600 hover:text-blue-500 rounded-full transition"
    //             aria-label="Back"
    //         >
    //             <ChevronLeft className="w-6 h-6" />
    //         </button>
    //         <h1 className="flex-grow text-center text-lg font-semibold text-gray-800 -ml-10">{title}</h1>
    //     </div>
    // </header>
);

// Success Modal Component
const SuccessModal = ({ productTitle, onClose, onGoToCart }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-60 transition-opacity duration-300 backdrop-blur-sm">
            <div className="bg-white w-full max-w-md p-6 rounded-t-3xl shadow-2xl animate-slideUp">

                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
                >
                    <XCircle className="w-7 h-7" />
                </button>

                <div className="flex flex-col items-center text-center space-y-4">
                    <div className="p-4 bg-green-100 rounded-full">
                        <ShoppingBag className="w-8 h-8 text-green-600" />
                    </div>

                    <h2 className="text-xl font-bold text-gray-900">Added to Cart!</h2>

                    <p className="text-sm text-gray-600">
                        <span className="font-semibold text-blue-600">{productTitle}</span> has been successfully added to your shopping cart.
                    </p>

                    <div className="w-full space-y-3 pt-4">
                        <button
                            onClick={onGoToCart}
                            className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200"
                        >
                            View Cart
                        </button>
                        <button
                            onClick={onClose}
                            className="w-full bg-white text-blue-600 border border-blue-600 py-3 rounded-xl font-semibold text-lg hover:bg-blue-50 transition duration-200"
                        >
                            Continue Shopping
                        </button>
                    </div>
                </div>
                <style jsx="true">{`
                    @keyframes slideUp {
                        from { transform: translateY(100%); }
                        to { transform: translateY(0); }
                    }
                    .animate-slideUp {
                        animation: slideUp 0.3s ease-out forwards;
                    }
                `}</style>
            </div>
        </div>
    );
};

// --- 1. PRODUCT DETAIL VIEW COMPONENT ---

// const ProductViews = ({ onAddToCart, onBack, setActiveScreen }) => {
//     const [bookInstallation, setBookInstallation] = useState(false);
//     const [showSuccessModal, setShowSuccessModal] = useState(false);

//     const handleAddToCart = () => {
//         onAddToCart(product);
//         setShowSuccessModal(true); // Show the success modal
//     };

//     // When user clicks 'Continue Shopping' in the modal or the 'X' close button
//     const handleCloseModal = () => {
//         setShowSuccessModal(false);
//         // Continue shopping means going back to the marketplace (orders screen)
//         setActiveScreen('orders'); 
//     };

//     // When user clicks 'View Cart' in the modal
//     const handleGoToCart = () => {
//         setShowSuccessModal(false);
//         // Navigates to the Checkout view managed by ProductViewWrapper
//         setActiveScreen('checkoutView'); 
//     };

//     return (
//         <div className="">
//             <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl sm:rounded-none relative"> 

//                 {/* Header: Go back to the Marketplace ('orders') */}
//                 <Header title="Product Detail" onBack={onBack} />

//                 {/* Scrollable Content Area */}
//                 <main className="flex-grow overflow-y-auto">

//                     {/* Product Image Card */}
//                     <div className="p-4 bg-white">
//                         <div className="bg-gray-100 rounded-xl overflow-hidden shadow-sm">
//                             <img 
//                                 src={product.image} 
//                                 alt={product.title} 
//                                 className="w-full h-auto object-cover rounded-xl"
//                                 onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/400x350/E0F0FF/3b82f6?text=Image+Unavailable"; }}
//                             />
//                         </div>
//                     </div>

//                     {/* Product Details Card */}
//                     <div className="p-5 bg-white space-y-4">
//                         <h1 className="text-xl font-bold text-gray-900">{product.title}</h1>

//                         <DetailSection title="PRODUCT PRICE">
//                             <p className="text-2xl font-extrabold text-blue-600">{product.displayPrice}</p>
//                         </DetailSection>

//                         <DetailSection title="PRODUCT FEATURE">
//                             <ul className="list-none p-0 m-0">
//                                 {product.features.map((feature, index) => (
//                                     <FeatureItem key={index} text={feature} />
//                                 ))}
//                             </ul>
//                         </DetailSection>

//                         <DetailSection title="LOAD CAPACITY">
//                             <p className="text-base text-gray-700 font-medium">{product.loadCapacity}</p>
//                         </DetailSection>

//                         <div className="py-4">
//                             <h2 className="text-sm font-bold text-gray-500 tracking-wider mb-2">POWER RATING</h2>
//                             <p className="text-base text-gray-700 font-medium">{product.powerRating}</p>
//                         </div>
//                     </div>

//                     {/* Book Installation Toggle Section */}
//                     <div className="mt-4 p-5 bg-white border-t border-b border-gray-200 flex items-center justify-between shadow-sm">
//                         <h2 className="text-lg font-semibold text-gray-800">Book Installation</h2>

//                         <label className="relative inline-flex items-center cursor-pointer">
//                             <input 
//                                 type="checkbox" 
//                                 className="sr-only peer" 
//                                 checked={bookInstallation} 
//                                 onChange={() => setBookInstallation(!bookInstallation)}
//                             />
//                             <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
//                         </label>
//                     </div>
//                 </main>

//                 {/* Fixed Footer Action */}
//                 <div className="sticky bottom-0 bg-white z-20 shadow-lg">
//                     <div className="p-4 border-t border-gray-100">
//                         <button 
//                             onClick={handleAddToCart}
//                             className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-600 transition duration-200 active:scale-[0.99]"
//                         >
//                             Add to cart
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* Conditional Success Modal */}
//             {showSuccessModal && (
//                 <SuccessModal 
//                     productTitle={product.title} 
//                     onClose={handleCloseModal} 
//                     onGoToCart={handleGoToCart}
//                 />
//             )}
//         </div>
//     );
// };
// const ProductViews = ({ onAddToCart, onBack, setActiveScreen,productId,authToken }) => {
//     const [bookInstallation, setBookInstallation] = useState(false);
//     const [showSuccessModal, setShowSuccessModal] = useState(false);

//     const handleAddToCart = () => {
//         onAddToCart(product);
//         setShowSuccessModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowSuccessModal(false);
//         setActiveScreen('orders');
//     };

//     const handleGoToCart = () => {
//         setShowSuccessModal(false);
//         setActiveScreen('checkoutView');
//     };


//   useEffect(() => {
//     if (!productId) return;

//     fetch(`https://psh-admin.zolute.xyz/api/products/${productId}`, {
//       headers: {
//         Authorization: `Bearer ${authToken}`
//       }
//     })
//       .then(res => res.json())
//       .then(data => {
//         console.log("Single Product:", data);
//       });

//   }, [productId]);

//     return (
//         // 1. Added h-full and flex-col to manage vertical space
//         <div className="bg-gray-100 font-inter flex flex-col h-full w-full">
//             {/* 2. Removed min-h-screen to fix scroll issue. Added relative for absolute footer */}
//             <div className="max-w-md mx-auto w-full bg-white shadow-xl flex flex-col relative flex-grow">

//                 {/* Header is now a static part of the flex container */}
//                 <Header title="Product Detail" onBack={onBack} />

//                 {/* Scrollable Content Area: flex-grow makes it take up remaining space. pb-20 leaves room for the fixed footer. */}
//                 <main className="flex-grow overflow-y-auto pb-20">

//                     {/* Product Image Card */}
//                     <div className="p-4 bg-white">
//                         <div className="bg-gray-100 rounded-xl overflow-hidden shadow-sm">
//                             <img
//                                 src={product.image}
//                                 alt={product.title}
//                                 className="w-full h-auto object-cover rounded-xl"
//                                 onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/400x350/E0F0FF/3b82f6?text=Image+Unavailable"; }}
//                             />
//                         </div>
//                     </div>

//                     {/* Product Details Card */}
//                     <div className="p-5 bg-white space-y-4">
//                         <h1 className="text-xl font-bold text-gray-900">{product.title}</h1>

//                         <DetailSection title="PRODUCT PRICE">
//                             <p className="text-2xl font-extrabold text-blue-600">{product.displayPrice}</p>
//                         </DetailSection>

//                         <DetailSection title="PRODUCT FEATURE">
//                             <ul className="list-none p-0 m-0">
//                                 {product.features.map((feature, index) => (
//                                     <FeatureItem key={index} text={feature} />
//                                 ))}
//                             </ul>
//                         </DetailSection>

//                         <DetailSection title="LOAD CAPACITY">
//                             <p className="text-base text-gray-700 font-medium">{product.loadCapacity}</p>
//                         </DetailSection>

//                         <div className="py-4">
//                             <h2 className="text-sm font-bold text-gray-500 tracking-wider mb-2">POWER RATING</h2>
//                             <p className="text-base text-gray-700 font-medium">{product.powerRating}</p>
//                         </div>
//                     </div>

//                     {/* Book Installation Toggle Section */}
//                     {/* <div className="mt-4 p-5 bg-white border-t border-b border-gray-200 flex items-center justify-between shadow-sm">
//                         <h2 className="text-lg font-semibold text-gray-800">Book Installation</h2>

//                         <label className="relative inline-flex items-center cursor-pointer">
//                             <input
//                                 type="checkbox"
//                                 className="sr-only peer"
//                                 checked={bookInstallation}
//                                 onChange={() => setBookInstallation(!bookInstallation)}
//                             />
//                             <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
//                         </label>
//                     </div> */}
//                 </main>

//                 {/* Fixed Footer Action - positioned absolutely at the bottom of the inner wrapper */}
//                 <div className="absolute bottom-0 left-0 right-0 bg-white z-20 shadow-lg">
//                     <div className="p-4 border-t border-gray-100">
//                         <button
//                             onClick={handleAddToCart}
//                             className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-600 transition duration-200 active:scale-[0.99]"
//                         >
//                             Add to cart
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* Conditional Success Modal */}
//             {showSuccessModal && (
//                 <SuccessModal
//                     productTitle={product.title}
//                     onClose={handleCloseModal}
//                     onGoToCart={handleGoToCart}
//                 />
//             )}
//         </div>
//     );
// };

const ProductViews = ({ onAddToCart, onBack, setActiveScreen, productId, authToken }) => {

    // State for data fetching and storage
    const [product, setProduct] = useState(null); // Will store the fetched product object
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // State for UI/Interactions
    const [bookInstallation, setBookInstallation] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);



    console.log(productId, 'checked if offline')

    // --- Data Fetching Logic ---
    const fetchProduct = useCallback(async () => {
        if (!productId) {
            setError("No product ID provided.");
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_BASE_URL}/products/${productId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                }
            });

            if (!response.ok) {
                const errorBody = await response.text();
                throw new Error(`Failed to fetch product. Status: ${response.status}. Detail: ${errorBody.substring(0, 100)}...`);
            }

            const data = await response.json();

            // 💡 CRITICAL: Get the product object from the API response
            const fetchedProduct = data?.data?.product;

            if (!fetchedProduct) {
                throw new Error("Product data is missing from the API response structure.");
            }

            setProduct(fetchedProduct);

        } catch (err) {
            console.error("Single Product Fetch Error:", err);
            setError(err.message);
            setProduct(null);
        } finally {
            setIsLoading(false);
        }
    }, [productId, authToken]);

    // Effect to trigger data fetching
    useEffect(() => {
        fetchProduct();
    }, [fetchProduct]);


    // --- UI Handlers ---

    // const handleAddToCart = () => {
    //     // Only call onAddToCart if the product data is loaded
    //     if (product) {
    //         onAddToCart(product);
    //         setShowSuccessModal(true);
    //     } else {
    //         console.warn("Product data not loaded, cannot add to cart.");
    //     }
    // };

    // const handleCloseModal = () => {
    //     setShowSuccessModal(false);
    //     setActiveScreen('orders');
    // };

    // const handleGoToCart = () => {
    //    
    //     onAddToCart(product);
    //     setActiveScreen('checkoutView', { productId });
    // };
// Inside ProductViews component
const handleGoToCart = () => {
    if (product) {
        // 1. Add to cart first
        onAddToCart(product);
        
        // 2. Then move to checkout
        setActiveScreen('checkoutView', { productId });
    }
};

    // --- Render Loading/Error States ---
    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-gray-100 p-8">
                <Loader2 className="w-10 h-10 animate-spin text-blue-600 mb-4" />
                <p className="text-gray-600 font-medium">Loading product details...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-white p-8">
                <AlertTriangle className="w-10 h-10 text-red-500 mb-4" />
                <p className="text-xl font-bold text-gray-800 mb-2">Error Loading Product</p>
                <p className="text-sm text-gray-600 text-center">{error}</p>
                <button onClick={onBack} className="mt-6 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition">
                    Go Back to Marketplace
                </button>
            </div>
        );
    }

    // This case should ideally not happen if error handling is correct, 
    // but serves as a final safeguard if data is null after loading.
    if (!product) {
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-white p-8">
                <AlertTriangle className="w-10 h-10 text-gray-400 mb-4" />
                <p className="text-xl font-bold text-gray-800 mb-2">Product Not Found</p>
                <button onClick={onBack} className="mt-6 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition">
                    Go Back
                </button>
            </div>
        )
    }

    // --- Data Mapping (Destructure for easier access) ---
    // NOTE: This assumes the product object is structured as shown in your API response JSON.
    const primaryImage = product.images && product.images.find(img => img.primary)?.url ||
        (product.images?.length > 0 ? product.images[0].url : null);

    // Specifications can be treated as 'features' for display purposes
    const features = product.specifications || [];

    const price = formatPrice(product.price);

    // --- Main Render (using fetched 'product' state) ---
    return (
        // <div className="bg-gray-100 font-inter flex flex-col h-full w-full">
        //     <div className="max-w-md mx-auto w-full bg-white shadow-xl flex flex-col relative flex-grow">
        <div className="bg-white font-inter flex flex-col h-screen w-full">
            {/* The main content wrapper: max-width for PWA feel, centered, full height, and RELATIVE for absolute footer */}
            {/* <div className="max-w-md mx-auto w-full bg-white shadow-xl flex flex-col relative h-full"> */}

            <Header title="Product Detail" onBack={onBack} />

            <main className="flex-grow overflow-y-auto">

                {/* Product Image Card */}
                <div className="p-4 bg-white">
                    <div className=" rounded-xl overflow-hidden shadow-sm aspect-[4/3] flex items-center justify-center">
                        <img
                            // 💡 USE PRIMARY IMAGE URL
                            src={primaryImage}
                            alt={product.name}
                            className="w-full h-full object-contain"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "https://placehold.co/400x350/E0F0FF/3b82f6?text=Image+Unavailable";
                            }}
                        />
                    </div>
                </div>

                {/* Product Details Card */}
                <div className="p-5 bg-white space-y-4">
                    {/* 💡 Use product.name */}
                    <h1 className="text-xl font-bold text-gray-900">{product.name}</h1>

                    {/* PRODUCT PRICE */}
                    <DetailSection title="PRODUCT PRICE">
                        {/* 💡 Use formatted price */}
                        <p className="text-2xl font-extrabold text-blue-600">{price}</p>
                    </DetailSection>

                    {/* PRODUCT DESCRIPTION */}
                    <DetailSection title="PRODUCT DESCRIPTION">
                        <p className="text-base text-gray-700">{product.description}</p>
                    </DetailSection>

                    {/* PRODUCT SPECIFICATIONS/FEATURES */}
                    {features.length > 0 && (
                        <DetailSection title="PRODUCT SPECIFICATIONS">
                            <ul className="list-none p-0 m-0 space-y-2">
                                {/* 💡 Map over specifications */}
                                {features.map((spec, index) => (
                                    <FeatureItem key={index} text={`${spec.property}: ${spec.value}`} />
                                ))}
                            </ul>
                        </DetailSection>
                    )}

                    {/* SELLER INFORMATION */}
                    {product.seller && (
                        <DetailSection title="SELLER">
                            <p className="text-base text-gray-700 font-medium">{product.seller.name} ({product.seller.code})</p>
                        </DetailSection>
                    )}

                    {/* STOCK */}
                    <DetailSection title="AVAILABILITY">
                        <p className={`text-base font-medium ${product.stock > 0 ? 'text-green-600' : 'text-red-600'}`}>
                            {product.stock > 0 ? `${product.stock} in stock` : 'Out of Stock'}
                        </p>
                    </DetailSection>

                </div>
            </main>

            {/* Fixed Footer Action */}
            {/* <div className="absolute bottom-0 left-0 right-0 bg-white z-20 shadow-lg">
                    <div className="p-4 border-t border-gray-100">
                        <button
                            onClick={handleGoToCart}
                            disabled={product.stock <= 0} // Disable if out of stock
                            className={`w-full text-white py-3 rounded-xl font-semibold text-lg shadow-lg transition duration-200 active:scale-[0.99] ${product.stock > 0
                                ? 'bg-blue-500 hover:bg-blue-600'
                                : 'bg-gray-400 cursor-not-allowed'
                                }`}
                        >
                            {product.stock > 0 ? 'Buy Now' : 'Out of Stock'}
                        </button>
                    </div>
                </div> */}
            {/* Fixed Footer Action (Buy Now Bar) - Changed from 'absolute' to 'fixed' */}
            <div className="fixed bottom-0 inset-x-0 bg-white z-30 shadow-2xl">
                <div className="max-w-md mx-auto p-4 border-t border-gray-100">
                    <button
                        onClick={handleGoToCart}
                        disabled={product.stock <= 0} // Disable if out of stock
                        className={`w-full text-white py-3 rounded-xl font-semibold text-lg shadow-lg transition duration-200 active:scale-[0.99] ${product.stock > 0
                            ? 'bg-blue-500 hover:bg-blue-600'
                            : 'bg-gray-400 cursor-not-allowed'
                            }`}
                    >
                        {product.stock > 0 ? 'Buy Now' : 'Out of Stock'}
                    </button>
                </div>
            </div>
            {/* </div> */}

            {/* Conditional Success Modal */}
            {/* {showSuccessModal && (
                <SuccessModal
                    productTitle={product.name}
                    onClose={handleCloseModal}
                    onGoToCart={handleGoToCart}
                />
            )} */}
        </div>
    );
};

// --- CHECKOUT ITEM COMPONENT ---

const CheckoutItem = ({ item, onUpdateQuantity, onRemove }) => {
    // const productNameLine = `${item.title.split(',')[0]}, ${item.title.split(',')[1].trim()}, ${item.title.split(',')[2].trim()}`;
    console.log(item, 'test item')
    const productNameLine = item.name
    return (
        <div className="flex justify-between items-start py-3 border-b border-gray-100">
            <div className="flex flex-grow items-start space-x-3">
                <img
                    src={item.images && item.images.length > 0 ? item.images[0].url : ''}
                    alt={item.name}
                    className="w-12 h-12 object-cover rounded-lg flex-shrink-0"
                // onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/48x48/E0F0FF/3b82f6?text=Item"; }}
                />
                <div className="flex-grow">
                    <p className="text-sm text-gray-900 font-medium leading-tight mb-1">{productNameLine}</p>
                    <p className="text-base font-bold text-gray-900">
                        NGN {formatPrice(item.price)}
                    </p>
                </div>
            </div>

            <div className="flex flex-col items-end space-y-1 ml-4">
                <button
                    onClick={() => onRemove(item.id)}
                    className="text-xs font-medium text-blue-600 hover:text-blue-700 transition self-end"
                >
                    Remove
                </button>

                <div className="flex items-center border border-gray-300 rounded-md mt-1">
                    <button
                        onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
                        disabled={item.quantity <= 1}
                        className="px-2 py-1 text-gray-500 disabled:text-gray-300 hover:bg-gray-100 transition rounded-l-md"
                    >
                        <Minus className="w-3 h-3" />
                    </button>
                    <span className="px-1 text-sm font-medium text-gray-700">
                        {item.quantity}
                    </span>
                    <button
                        onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                        className="px-2 py-1 text-gray-500 hover:bg-gray-100 transition rounded-r-md"
                    >
                        <Plus className="w-3 h-3" />
                    </button>
                </div>
            </div>
        </div>
    );
};

// --- 2. CHECKOUT VIEW COMPONENT ---

// const CheckoutView = ({ cartItems, setCartItems, onBack, setActiveScreen, productId }) => {


//     console.log('test cart item', cartItems)
//     const handleUpdateQuantity = (id, newQuantity) => {
//         if (newQuantity < 1) return;
//         setCartItems(prevItems =>
//             prevItems.map(item => item.id === id ? { ...item, quantity: newQuantity } : item)
//         );
//     };

//     const handleRemoveItem = (id) => {
//         setCartItems(prevItems => prevItems.filter(item => item.id !== id));
//     };

//     const cartCalculations = useMemo(() => {
//         const total = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
//         return { total };
//     }, [cartItems]);

//     // Check for empty cart
//     if (cartItems.length === 0) {
//         return (
//             <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl sm:rounded-none relative">
//                 <Header title="Checkout" onBack={onBack} />
//                 <div className="flex-grow flex flex-col items-center justify-center p-8 text-center">
//                     <ShoppingCart className="w-16 h-16 text-gray-300 mb-4" />
//                     <h2 className="text-xl font-semibold text-gray-700 mb-2">Your Cart is Empty</h2>
//                     <p className="text-gray-500 mb-6">Start shopping to proceed to checkout.</p>
//                     <button
//                         onClick={() => setActiveScreen('orders')} // Go back to Marketplace
//                         className="bg-blue-600 text-white py-2 px-6 rounded-xl font-semibold shadow-md hover:bg-blue-700 transition"
//                     >
//                         Start Shopping
//                     </button>
//                 </div>
//             </div>
//         );
//     }

//     const { total } = cartCalculations;

//     return (
//         // <div className="">
//             // <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl sm:rounded-none relative">
// <div className="bg-gray-100 font-inter flex flex-col h-screen w-full">
//                 {/* Header: Go back to the Product Detail View */}
//                 <Header title="Checkout" onBack={onBack} />

//                 {/* Scrollable Content Area */}
//                 <main className="flex-grow overflow-y-auto p-4">

//                     <h2 className="text-xl font-bold text-gray-900 mb-4 text-center">Your cart items</h2>

//                     {/* Back to Shopping link - Goes to Marketplace */}
//                     <button
//                         onClick={() => setActiveScreen('orders', { productId })}
//                         className="text-blue-600 font-semibold text-sm block mx-auto mb-6 hover:underline"
//                     >
//                         Back to shopping
//                     </button>

//                     <div className="flex justify-between border-b border-gray-300 pb-2 mb-2 px-2">
//                         <span className="text-xs uppercase font-bold text-gray-500 w-1/2">Product</span>
//                         <span className="text-xs uppercase font-bold text-gray-500 w-1/2 text-right">Price/Quantity</span>
//                     </div>

//                     {/* Cart Items List */}
//                     <div className="space-y-4">
//                         {cartItems.map(item => (
//                             <CheckoutItem
//                                 key={item.id}
//                                 item={item}
//                                 onUpdateQuantity={handleUpdateQuantity}
//                                 onRemove={handleRemoveItem}
//                             />
//                         ))}
//                     </div>

//                 </main>

//                 {/* Fixed Footer Total and Pay Now Button */}
//                 <div className="absolute bottom-0 left-0 right-0 bg-white z-20 shadow-lg border-t border-gray-200">
//                     <div className="flex justify-between items-center p-4">
//                         <div className="flex flex-col">
//                             <span className="text-xs text-gray-500">Total price</span>
//                             <p className="text-lg font-bold text-blue-600">
//                                 {formatPrice(total)} NGN
//                             </p>
//                         </div>

//                         <button
//                             // FIX: Instead of logging, we call the prop to switch to the next checkout step
//                             onClick={() => setActiveScreen('addressView')}
//                             className="bg-blue-600 text-white py-3 px-8 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200"
//                         >
//                             Pay Now
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         // </div>
//     );
// };
const CheckoutView = ({ cartItems, setCartItems, onBack, setActiveScreen, productId,onBackToMarketplace }) => {

    const handleUpdateQuantity = (id, newQuantity) => {
        if (newQuantity < 1) return;
        setCartItems(prevItems =>
            prevItems.map(item => item.id === id ? { ...item, quantity: newQuantity } : item)
        );
    };

    const handleRemoveItem = (id) => {
        setCartItems(prevItems => prevItems.filter(item => item.id !== id));
        //   localStorage.removeItem(OFFLINE_CHECKOUT_STATE_KEY);
        //  setActiveScreen('orders')
        // onBackToMarketplace()
    };

    const cartCalculations = useMemo(() => {
        const total = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        return { total };
    }, [cartItems]);

    // Check for empty cart
    if (cartItems.length === 0) {
        return (
            // <div className="bg-gray-100 font-inter flex flex-col h-screen w-full">
            // <div className="max-w-md mx-auto w-full bg-white shadow-xl flex flex-col relative h-full">
            <div className="bg-white font-inter flex flex-col h-screen w-full">
                <Header title="Checkout" onBack={onBack} />
                <div className="flex-grow flex flex-col items-center justify-center p-8 text-center">
                    <ShoppingCart name="ShoppingCart" className="w-16 h-16 text-gray-300 mb-4" />
                    <h2 className="text-xl font-semibold text-gray-700 mb-2">Your Cart is Empty</h2>
                    <p className="text-gray-500 mb-6">Start shopping to proceed to checkout.</p>
                    <button
                        onClick={onBackToMarketplace}
                        className="bg-blue-600 text-white py-2 px-6 rounded-xl font-semibold shadow-md hover:bg-blue-700 transition"
                    >
                        Start Shopping
                    </button>
                </div>
            </div>
            // </div>
        );
    }

    const { total } = cartCalculations;

    return (
        // <div className="bg-gray-100 font-inter flex flex-col h-screen w-full">
        //<div className="max-w-md mx-auto w-full bg-white shadow-xl flex flex-col relative h-full"> 
        <div className="bg-white font-inter flex flex-col h-screen w-full">

            <Header title="Checkout" onBack={onBack} />

            {/* Scrollable Content Area */}
            {/* IMPORTANT FIX: Increased padding bottom (pb-28) to clear the fixed footer */}
            <main className="flex-grow overflow-y-auto p-4 pb-28">

                <h2 className="text-xl font-bold text-gray-900 mb-4 text-center">Your Cart Items</h2>

                {/* Back to Shopping link - Goes to Marketplace */}
                <button
                    // onClick={() => setActiveScreen('orders', { productId })}
                    onClick={onBackToMarketplace}
                    className="text-blue-600 font-semibold text-sm block mx-auto mb-6 hover:underline"
                >
                    &larr; Back to Shopping
                </button>

                <div className="flex justify-between border-b border-gray-300 pb-2 mb-2 px-2">
                    <span className="text-xs uppercase font-bold text-gray-500 w-1/2">Product</span>
                    <span className="text-xs uppercase font-bold text-gray-500 w-1/2 text-right">Price/Quantity</span>
                </div>

                {/* Cart Items List */}
                <div className="space-y-4">
                    {cartItems.map(item => (
                        <CheckoutItem
                            key={item.id}
                            item={item}
                            onUpdateQuantity={handleUpdateQuantity}
                            onRemove={handleRemoveItem}
                        />
                    ))}
                </div>

            </main>

            {/* Fixed Footer Total and Pay Now Button */}
            {/* IMPORTANT FIX: Changed from 'absolute' to 'fixed' and added centering/width classes */}
            <div className="fixed bottom-0 inset-x-0 z-30 shadow-2xl bg-white">
                <div className="max-w-md mx-auto border-t border-gray-200 py-3 px-4">
                    <div className="flex justify-between items-center">
                        <div className="flex flex-col">
                            <span className="text-xs text-gray-500">Total price</span>
                            <p className="text-xl font-bold text-blue-600">
                                {formatPrice(total)}
                            </p>
                        </div>

                        <button
                            onClick={() => setActiveScreen('addressView')}
                            className="bg-blue-600 text-white py-3 px-8 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200 active:scale-[0.99]"
                        >
                            Pay Now
                        </button>
                    </div>
                </div>
            </div>
            {/* </div> */}
        </div>
    );
};
// --- 3. ADDRESS DETAILS VIEW COMPONENT ---


const isEmail = (input) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);

const isNigerianPhone = (input) => {
  const cleaned = input.replace(/\s+/g, '');
  return /^(?:\+234|234|0)(7[0-9]|8[0-9]|9[0-9])[0-9]{8}$/.test(cleaned);
};

const AddressDetailsView = ({ onBack, onContinue, initialData, setActiveScreen,userSession }) => {

    // 💡 NEW STATE: To manage all form inputs
    const [formData, setFormData] = useState(initialData || {
        email: userSession.email,
         mobile: '',
        name: userSession.name,
        secondName: '',
        address: '',
        shippingNote: '',
        postalCode: '',
        city: '',
        province: 'Lazio', // Default value
        country: 'Nigeria', // Default value
        saveInfo: false,
    });

    // const handleChange = (e) => {
    //     const { name, value, type, checked } = e.target;
    //     setFormData(prevData => ({
    //         ...prevData,
    //         [name]: type === 'checkbox' ? checked : value,
    //     }));
    // };

    // // Handler for continuing to the next step
    // const handleContinueToPayment = (e) => {
    //     e.preventDefault();
    //     // 💡 ACTION: Call the prop with the captured form data
    //     // NEW ACTION: Switch to the PaymentConfirmationView
    //     // setActiveScreen('confirmationView');

    //     onContinue(formData);
    // };

    const [contactError, setContactError] = useState('');

    const [emailError, setEmailError] = useState('');
const [mobileError, setMobileError] = useState('');


    // Update handleChange to also check contact input validity
    // const handleChange = useCallback((e) => {
    //     const { name, value, type, checked } = e.target;

    //     setFormData(prevData => {
    //         const newData = {
    //             ...prevData,
    //             [name]: type === 'checkbox' ? checked : value,
    //         };

    //         // 💡 VALIDATION LOGIC FOR THE CONTACT FIELD
    //         if (name === 'email') {
    //             setContactError(''); // Clear error on change

    //             if (value.length > 0) {
    //                 if (!isEmail(value) && !isPhoneNumber(value)) {
    //                     setContactError('Please enter a valid email or phone number.');
    //                 }
    //             }
    //         }
    //         return newData;
    //     });
    // }, []);

    const handleChange = useCallback((e) => {
  const { name, value, type, checked } = e.target;

  setFormData(prev => ({
    ...prev,
    [name]: type === 'checkbox' ? checked : value,
  }));

  if (name === 'email') {
    setEmailError(
      value && !isEmail(value) ? 'Enter a valid email address.' : ''
    );
  }

  if (name === 'mobile') {
    setMobileError(
      value && !isNigerianPhone(value) ? 'Enter a valid Nigerian phone number.' : ''
    );
  }
}, []);


    // Handler for continuing to the next step
    // const handleContinueToPayment = (e) => {
    //     e.preventDefault();
        
    //     // Final contact validation check on submit
    //     if (!isEmail(formData.email) && !isPhoneNumber(formData.email)) {
    //          setContactError('A valid email or phone number is required to proceed.');
    //          return; // Block submission
    //     }

    //     onContinue(formData);
    // };
    const handleContinueToPayment = (e) => {
  e.preventDefault();

  if (!isEmail(formData.email)) {
    setEmailError('Valid email is required for payment.');
    return;
  }

  if (formData.mobile && !isNigerianPhone(formData.mobile)) {
    setMobileError('Invalid Nigerian phone number.');
    return;
  }

  onContinue(formData);
};

    // Helper to determine the current input type for icon/placeholder
    // const getContactStatus = (input) => {
    //     if (input.length === 0) return 'empty';
    //     if (isEmail(input)) return 'email';
    //     if (isPhoneNumber(input)) return 'phone';
    //     return 'invalid';
    // };

    // const contactStatus = getContactStatus(formData.email);

    return (
        // <div className="bg-gray-100 font-inter flex flex-col h-full w-full">
        <div className="bg-white font-inter flex flex-col h-screen w-full">
            {/* <div className="max-w-md mx-auto w-full bg-white shadow-xl relative flex-grow overflow-hidden"> */}
            <Header title="Checkout" onBack={onBack} />

            {/* Wrap main content in a form element */}
            <form onSubmit={handleContinueToPayment} className="h-full flex flex-col">

                <main className="flex-grow overflow-y-auto p-4 pt-6 pb-24">

                    {/* Contact Section */}
                    {/* <div className="mb-8">
                        <h3 className="text-lg font-semibold text-gray-800 mb-3">Contact</h3>
                        <input
                            type="email"
                            name="email" // 💡 ADD NAME
                            value={formData.email} // 💡 BIND VALUE
                            onChange={handleChange} // 💡 BIND HANDLER
                            placeholder="Email or mobile phone number"
                            required // 💡 ADD VALIDATION
                            className="w-full p-3 border border-gray-300 rounded-xl focus:ring-blue-500 focus:border-blue-500 transition duration-150"
                        />
                    </div> */}

                    {/* Contact Section */}
                    <div className="mb-8">
                        <h3 className="text-lg font-semibold text-gray-800 mb-3">Contact</h3>
                        
                      
                        {/* <div className="relative">
                            <input
                                
                                type="text"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Email or mobile phone number"
                                required
                                className={`w-full p-3 border rounded-xl focus:ring-blue-500 focus:border-blue-500 transition duration-150 pr-10 ${
                                    contactError ? 'border-red-500' : 'border-gray-300'
                                }`}
                            />
                            
                            
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                {contactStatus === 'email' && <Mail className="w-5 h-5 text-green-500" />}
                                {contactStatus === 'phone' && <Phone className="w-5 h-5 text-green-500" />}
                                {contactStatus === 'invalid' && formData.email.length > 0 && <XCircle className="w-5 h-5 text-red-500" />}
                            </div>
                        </div>

                   
                        {contactError && (
                            <p className="mt-1 text-sm text-red-500 flex items-center">
                                <XCircle className="w-4 h-4 mr-1" />
                                {contactError}
                            </p>
                        )} */}
                        <div className="mb-4">
  <label className="block text-sm font-medium text-gray-700 mb-1">
    Email Address
  </label>
  <input
    type="email"
    name="email"
    value={formData.email}
    onChange={handleChange}
    required
    placeholder="you@example.com"
    className={`w-full p-3 border rounded-xl ${
      emailError ? 'border-red-500' : 'border-gray-300'
    }`}
  />
  {emailError && <p className="text-sm text-red-500 mt-1">{emailError}</p>}
</div>
<div className="mb-6">
  <label className="block text-sm font-medium text-gray-700 mb-1">
    Mobile Number
  </label>
  <input
    type="tel"
    name="mobile"
    value={formData.mobile}
    onChange={handleChange}
    placeholder="08012345678"
    className={`w-full p-3 border rounded-xl ${
      mobileError ? 'border-red-500' : 'border-gray-300'
    }`}
  />
  {mobileError && <p className="text-sm text-red-500 mt-1">{mobileError}</p>}
</div>

                    </div>

                    {/* Shipping Address Section */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-gray-800 mb-3">Shipping Address</h3>
                        <input name="name" value={formData.name} onChange={handleChange} required placeholder="Name" className="w-full p-3 border border-gray-300 rounded-xl" />
                        <input name="secondName" value={formData.secondName} onChange={handleChange} placeholder="Second Name" className="w-full p-3 border border-gray-300 rounded-xl" />
                        <input name="address" value={formData.address} onChange={handleChange} required placeholder="Address and number" className="w-full p-3 border border-gray-300 rounded-xl" />
                        <input name="shippingNote" value={formData.shippingNote} onChange={handleChange} placeholder="Shipping note (optional)" className="w-full p-3 border border-gray-300 rounded-xl" />
                        <input name="postalCode" value={formData.postalCode} onChange={handleChange} placeholder="Postal Code" className="w-full p-3 border border-gray-300 rounded-xl" />
                        <input name="city" value={formData.city} onChange={handleChange} required placeholder="City" className="w-full p-3 border border-gray-300 rounded-xl" />

                        <select name="province" value={formData.province} onChange={handleChange} required className="w-full p-3 border border-gray-300 rounded-xl appearance-none bg-white pr-8">
                            <option disabled value="">Select your province</option>
                            <option>Lazio</option>
                            <option>Lombardia</option>
                            <option>Other</option>
                        </select>

                        {/* <select name="country" value={formData.country} onChange={handleChange} required className="w-full p-3 border border-gray-300 rounded-xl appearance-none bg-white pr-8">
                            <option>Italy</option>
                            <option>Nigeria</option>
                            <option>USA</option>
                        </select> */}
                        <div className="relative">
  <div className="flex items-center w-full p-3 border border-gray-300 rounded-xl bg-gray-50">
    <img
      src="https://flagcdn.com/w20/ng.png"
      alt="Nigeria"
      className="w-6 h-4 mr-3 rounded-sm"
    />
    <span className="font-medium text-gray-800">Nigeria</span>
  </div>
</div>


                        <div className="flex items-center pt-2">
                            <input
                                type="checkbox"
                                id="saveInfo"
                                name="saveInfo" // 💡 ADD NAME
                                checked={formData.saveInfo} // 💡 BIND CHECKED
                                onChange={handleChange} // 💡 BIND HANDLER
                                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <label htmlFor="saveInfo" className="ml-2 text-sm text-gray-700">
                                Save this information for a future fast checkout
                            </label>
                        </div>
                    </div>
                </main>

                {/* Fixed Footer Action */}
                {/* <div className="absolute bottom-0 left-0 right-0 bg-white z-20 shadow-lg border-t border-gray-200"> */}
                <div className="fixed bottom-0 inset-x-0 z-30 shadow-2xl bg-white">
                    <div className="max-w-md mx-auto border-t border-gray-200 px-4">
                        <div className="p-4">
                            <button
                                type="submit" // 💡 SET TO SUBMIT
                                className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200"
                            >
                                Continue to Payment
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        // </div>
    );
};

// --- 4. PAYMENT CONFIRMATION VIEW COMPONENT ---

// --- 4. PAYMENT CONFIRMATION VIEW COMPONENT (Updated to match image 2) ---

const PaymentConfirmationView = ({ cartItems, onBack, onGoToNextStep, shippingDetails,setCartItems,onBackToMarketplace }) => {
    // Mock user data for display (in a real app, this would come from state/API)
    // NOTE: Hardcoded for demonstration as actual form data isn't tracked in this wrapper.
    const mockContact = "joe.spagnuolo@uxbly.com";
    const mockShipping = "Via Firenze 23, 92023, Campobello di Licata AG, Italia";

    // Calculates the total price from the items
    // const cartCalculations = useMemo(() => {
    //     const total = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    //     return { total };
    // }, [cartItems]);


    // const handleGoToNextStep = () => {
    //     // NEW ACTION: Switch to the FinalPaymentView
    //     onGoToNextStep('paymentView');
    // };
    // const { total } = cartCalculations;// 💡 NEW LOGIC: Use actual data or fallback to a placeholder if data is missing
    
    const contactEmail = shippingDetails?.email || '';

const contactMobNo = shippingDetails?.mobile || '';



    console.log(shippingDetails,'testing details ')
    // const contactMob = shippingDetails?.
    const shippingAddress = shippingDetails
        ? `${shippingDetails.address}, ${shippingDetails.postalCode}, ${shippingDetails.city}, ${shippingDetails.country}`
        : 'N/A';

    // Calculates the total price from the items (remains the same)


           


    const cartCalculations = useMemo(() => {
        const total = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        return { total };
    }, [cartItems]);



        const handleRemoveItem = (id) => {
        setCartItems(prevItems => prevItems.filter(item => item.id !== id));
        //   localStorage.removeItem(OFFLINE_CHECKOUT_STATE_KEY);
        //  setActiveScreen('orders')
        // onBackToMarketplace()
    };



    // Check for empty cart
    if (cartItems.length === 0) {
        return (
            // <div className="bg-gray-100 font-inter flex flex-col h-screen w-full">
            // <div className="max-w-md mx-auto w-full bg-white shadow-xl flex flex-col relative h-full">
            <div className="bg-white font-inter flex flex-col h-screen w-full">
                <Header title="Checkout" onBack={onBack} />
                <div className="flex-grow flex flex-col items-center justify-center p-8 text-center">
                    <ShoppingCart name="ShoppingCart" className="w-16 h-16 text-gray-300 mb-4" />
                    <h2 className="text-xl font-semibold text-gray-700 mb-2">Your Cart is Empty</h2>
                    <p className="text-gray-500 mb-6">Start shopping to proceed to checkout.</p>
                    <button
                        onClick={onBackToMarketplace}
                        className="bg-blue-600 text-white py-2 px-6 rounded-xl font-semibold shadow-md hover:bg-blue-700 transition"
                    >
                        Start Shopping
                    </button>
                </div>
            </div>
            // </div>
        );
    }
    
    const handleGoToNextStep = () => {
        onGoToNextStep('paymentView');
    };
    const { total } = cartCalculations;

    return (
        <div className="bg-white font-inter flex flex-col h-full w-full">
            {/* <div className="max-w-md mx-auto w-full bg-white shadow-xl relative flex-grow overflow-hidden"> */}

            {/* Header: Goes back to Address Details View */}
            <Header title="Checkout" onBack={onBack} />

            {/* Scrollable Content Area: pt-16 for header, pb-36 for footer */}
            <main className="h-full overflow-y-auto p-4 pt-6 pb-36">

                <h2 className="text-xl font-bold text-gray-900 mb-6 text-center">Your cart items</h2>

                {/* Product and Price Header (Matching image 2) */}
                <div className="flex justify-between border-b border-gray-300 pb-2 mb-4">
                    <span className="text-xs uppercase font-bold text-gray-500 w-1/2">Product</span>
                    <span className="text-xs uppercase font-bold text-gray-500 w-1/2 text-right">Price</span>
                </div>

                {/* Cart Item Display (Matching image 2 style) */}
                {cartItems.map(item => (
                    <div key={item.id} className="flex justify-between items-start py-3 border-b border-gray-100">
                        <div className="flex items-start space-x-3 w-1/2">
                            <img
                                src={item.images && item.images.length > 0 ? item.images[0].url : ''}
                                alt={item.name}
                                className="w-16 h-12 object-cover rounded-lg flex-shrink-0"
                                onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/64x48/E0F0FF/3b82f6?text=Item"; }}
                            />
                            <div className="flex-grow">
                                {/* Using the full title for flexibility, but displaying the main part */}
                                {/* <p className="text-sm text-gray-900 font-medium leading-tight">{item.title.split(',')[0].trim()}</p> */}
                                <p className="text-sm text-gray-900 font-medium leading-tight">{item.name}</p>
                                <button className="text-blue-600 font-medium text-xs hover:underline" onClick={()=>handleRemoveItem(item.id)}>Remove</button>
                            </div>
                        </div>

                        <div className="flex flex-col items-end w-1/2 space-y-2">
                            {/* Price */}
                            <p className="text-sm font-bold text-gray-900">{formatPrice(item.price)} NGN</p>

                            {/* Quantity Box (Simplified for this view, matching image 2's look) */}
                            <div className="flex items-center border border-gray-300 rounded-md">
                                <button disabled className="px-2 py-1 text-gray-300 transition rounded-l-md"><Minus className="w-3 h-3" /></button>
                                <span className="px-1 text-sm font-medium text-gray-700">{item.quantity}</span>
                                <button disabled className="px-2 py-1 text-gray-300 transition rounded-r-md"><Plus className="w-3 h-3" /></button>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Contact & Shipping Summary Block (Matching image 2 style) */}
                <div className="mt-8 p-4 border border-gray-300 rounded-xl space-y-4">

                    {/* Contact Row */}
                    <div className="flex justify-between items-start border-b border-gray-200 pb-4">
                        <div className="text-sm flex-grow pr-4">
                            <div className="text-gray-500 inline-block w-16">Contact</div>
                            <span className="text-gray-700 font-medium">{contactEmail}</span>
                        </div>
                        <button className="text-blue-600 font-medium text-sm flex-shrink-0" onClick={onBack}>Edit</button>
                    </div>

                    {/* Ship To Row */}
                    <div className="flex justify-between items-start pt-2">
                        <div className="text-sm flex-grow pr-4">
                            <div className="text-gray-500 inline-block w-16">Ship to</div>
                            <span className="text-gray-700 font-medium max-w-xs block sm:inline-block pl-16 -mt-4 sm:pl-0 sm:mt-0">{shippingAddress}</span>
                        </div>
                        <button className="text-blue-600 font-medium text-sm flex-shrink-0" onClick={onBack}>Edit</button>
                    </div>
                </div>

                {/* Shipping Method Section (Matching image 2 style) */}
                <div className="mt-8">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">Shipping method</h3>
                    <div className="p-4 flex justify-between items-center border border-gray-300 rounded-xl">
                        <div className="flex items-center">
                            <input type="radio" checked readOnly className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" />
                            <label className="ml-3 text-base font-medium text-gray-700">Standard Shipping</label>
                        </div>
                        <span className="font-semibold text-green-600">Free</span>
                    </div>
                </div>

            </main>

            {/* Fixed Footer Action (Matching image 2 style buttons) */}
            <div className="fixed bottom-0 inset-x-0 z-30 shadow-2xl bg-white">
                <div className="max-w-md mx-auto border-t border-gray-200 py-2 px-4">
                    {/* Go to payment button */}
                    <button
                        onClick={handleGoToNextStep}
                        className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200"
                    >
                        Go to payment
                    </button>
                    {/* Back to details button */}
                    {/* <button
                            onClick={onBack}
                            className="w-full bg-white text-gray-600 border border-gray-300 py-3 rounded-xl font-semibold text-lg hover:bg-gray-50 transition duration-200"
                        >
                            Back to details
                        </button> */}
                </div>
            </div>
        </div>
        // </div>
    );
};


// --- 5. FINAL PAYMENT VIEW COMPONENT ---

// --- 5. FINAL PAYMENT VIEW COMPONENT (Updated to strictly match image 3) ---

// const FinalPaymentView = ({ cartItems, onBack, setActiveScreen, shippingDetails, authToken }) => {
//     // Mock user data for display (must be consistent across checkout steps)
//     const ORDER_API_URL = "https://psh-admin.zolute.xyz/api/orders"
//     // NOTE: These details would typically be passed down as props from the AddressDetailsView
//     const [isProcessing, setIsProcessing] = useState(false); // NEW State for loading
//     const contactEmail = shippingDetails?.email || 'N/A';
//     const shippingAddress = shippingDetails
//         ? `${shippingDetails.address}, ${shippingDetails.postalCode}, ${shippingDetails.city}, ${shippingDetails.country}`
//         : 'N/A';

//     const mockMethod = "Standard Shipping - FREE";

//     const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('card');

//     const cartCalculations = useMemo(() => {
//         // We use the price from the cart items for calculation
//         const total = cartItems.reduce((sum, item) => item.price * item.quantity, 0);
//         return { total };
//     }, [cartItems]);

//     const { total } = cartCalculations;



//     const handlePayNow = async () => {
//         if (isProcessing) return; // Prevent double submission

//         // 1. Construct the Payload (assuming a multi-item cart structure is supported)
//         const orderItems = cartItems.map(item => ({
//             product: item.id, // Assuming 'id' is the product identifier expected by the API
//             quantity: item.quantity,
//             // Assuming the API expects the address for each item, or an array wrapper
//         }));

//         // *ADAPTED PAYLOAD* based on your single-item example, but supporting multiple
//         // If your API expects a single product, you will need to map this logic differently.
//         // Assuming the API takes the *first* item and the full address.
//         const payload = {
//             product: orderItems[0].product,
//             quantity: orderItems[0].quantity,
//             address: shippingAddress,
//             // Optionally add the payment method, though payment gateway is usually external
//             paymentMethod: selectedPaymentMethod,
//         };

//         console.log("Order Payload:", payload);

//         setIsProcessing(true);
//         try {
//             const response = await fetch(ORDER_API_URL, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${authToken}`, // Use Auth Token
//                 },
//                 body: JSON.stringify(payload),
//             });

//             const result = await response.json();

//             if (response.ok) {
//                 console.log('Order successful:', result);
//                 // Move to the success view, passing transaction data/total if needed
//                 // const orderId = result.data?.order.id ;
//                 setActiveScreen('successView', {
//                     orderId: result.data?.order.id,
//                     totalAmount: result.data?.order.amount,
//                     paymentMethod: selectedPaymentMethod,
//                 });
//             } else {
//                 console.error('Order placement failed:', result);
//                 alert(`Payment failed: ${result.message || 'An unknown error occurred.'}`);
//             }
//         } catch (error) {
//             console.error('Network or system error during order placement:', error);
//             alert('A network error occurred. Please check your connection and try again.');
//         } finally {
//             setIsProcessing(false);
//         }
//     };
//     // Using the first item for the detailed display based on the image style
//     const firstItem = cartItems[0] // Fallback to 'product' mock if cart is empty


//     return (
//         <div className="bg-white font-inter flex flex-col h-full w-full">
//             {/* <div className="max-w-md mx-auto w-full bg-white shadow-xl relative flex-grow overflow-hidden"> */}

//             {/* Header: Goes back to the Payment Confirmation View */}
//             <Header title="Checkout" onBack={onBack} />

//             {/* Scrollable Content Area: pt-16 for header, pb-24 for sticky footer */}
//             <main className="h-full overflow-y-auto p-4 pt-6 pb-24">

//                 <h2 className="text-xl font-bold text-gray-900 mb-6 text-center">Your cart items</h2>
//                 <button
//                     onClick={() => console.log('Back to shopping')}
//                     className="text-blue-600 font-semibold text-sm block mx-auto mb-6 hover:underline mt-[-10px]"
//                 >
//                     Back to shopping
//                 </button>


//                 {/* Product and Price Header */}
//                 <div className="flex justify-between border-b border-gray-300 pb-2 mb-4">
//                     <span className="text-xs uppercase font-bold text-gray-500 w-1/2">Product</span>
//                     <span className="text-xs uppercase font-bold text-gray-500 w-1/2 text-right">Price</span>
//                 </div>

//                 {/* Cart Item Display (Matching image 3 style) */}
//                 {cartItems.map(item => (
//                     <div key={item.id} className="flex justify-between items-start py-3 border-b border-gray-100">
//                         <div className="flex items-start space-x-3 w-1/2">
//                             <img
//                                 src={item.images && item.images.length > 0 ? item.images[0].url : ''}
//                                 alt={item.name}
//                                 className="w-16 h-12 object-cover rounded-lg flex-shrink-0"
//                             // onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/64x48/E0F0FF/3b82f6?text=Item"; }}
//                             />
//                             <div className="flex-grow">
//                                 <p className="text-sm text-gray-900 font-medium leading-tight">{item.name}</p>
//                                 <button className="text-blue-600 font-medium text-xs hover:underline">Remove</button>
//                             </div>
//                         </div>

//                         <div className="flex flex-col items-end w-1/2 space-y-2">
//                             <p className="text-sm font-bold text-gray-900">{formatPrice(item.price)} NGN</p>
//                             {/* Quantity Box matching image 3's simplified style */}
//                             <div className="flex items-center border border-gray-300 rounded-md">
//                                 <span className="px-2 py-1 text-sm font-medium text-gray-700">{item.quantity}</span>
//                                 <button disabled className="px-1 py-1 text-gray-300 rounded-r-md"><Plus className="w-3 h-3" /></button>
//                             </div>
//                         </div>
//                     </div>
//                 ))}

//                 {/* Contact, Ship To, and Method Summary Block (Matching image 3 style) */}
//                 <div className="mt-8 p-4 border border-gray-300 rounded-xl space-y-3">

//                     {/* Contact Row */}
//                     <div className="flex justify-between items-start">
//                         <div className="text-sm flex-grow pr-4">
//                             <span className="text-gray-500 inline-block w-16">Contact</span>
//                             <span className="text-gray-700 font-medium">{contactEmail}</span>
//                         </div>
//                         <button className="text-blue-600 font-medium text-sm flex-shrink-0">Edit</button>
//                     </div>

//                     {/* Ship To Row */}
//                     <div className="flex justify-between items-start">
//                         <div className="text-sm flex-grow pr-4">
//                             <span className="text-gray-500 inline-block w-16">Ship to</span>
//                             <span className="text-gray-700 font-medium max-w-xs block sm:inline-block pl-16 -mt-4 sm:pl-0 sm:mt-0">{shippingAddress}</span>
//                         </div>
//                         <button className="text-blue-600 font-medium text-sm flex-shrink-0">Edit</button>
//                     </div>

//                     {/* Method Row - Note: Added border-t only to the Method row as per image structure */}
//                     <div className="flex justify-between items-start border-t border-gray-200 pt-3">
//                         <div className="text-sm flex-grow pr-4">
//                             <span className="text-gray-500 inline-block w-16">Method</span>
//                             <span className="text-gray-700 font-medium">{mockMethod}</span>
//                         </div>
//                         <button className="text-blue-600 font-medium text-sm flex-shrink-0">Edit</button>
//                     </div>
//                 </div>

//                 {/* Choose Payment Method Section (Matching image 3 style - separate blue rounded box) */}
//                 <div className="mt-8 p-4 bg-blue-50 rounded-xl border border-blue-200">
//                     <h3 className="text-lg font-semibold text-gray-800 mb-4">Choose Payment Method</h3>
//                     <div className="flex space-x-8">
//                         {/* Debit/Credit Card */}
//                         <label className="flex items-center space-x-2 cursor-pointer">
//                             <input
//                                 type="radio"
//                                 name="payment"
//                                 value="card"
//                                 checked={selectedPaymentMethod === 'card'}
//                                 onChange={() => setSelectedPaymentMethod('card')}
//                                 className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
//                             />
//                             <span className="text-sm text-gray-700">💳 Debit/Credit Card</span>
//                         </label>

//                         {/* Net Banking */}
//                         <label className="flex items-center space-x-2 cursor-pointer">
//                             <input
//                                 type="radio"
//                                 name="payment"
//                                 value="net_banking"
//                                 checked={selectedPaymentMethod === 'net_banking'}
//                                 onChange={() => setSelectedPaymentMethod('net_banking')}
//                                 className="w-4 h-4 text-gray-300 border-gray-300 focus:ring-gray-500"
//                             />
//                             <span className="text-sm text-gray-700">Net Banking</span>
//                         </label>
//                     </div>
//                 </div>

//             </main>

//             {/* Fixed Footer Action (Total price and Pay Now button) - MATCHING IMAGE 3 EXACTLY */}
//             {/* <div className="absolute bottom-0 left-0 right-0 bg-white z-20 shadow-lg border-t border-gray-200"> */}
//             <div className="fixed bottom-0 inset-x-0 z-30 shadow-2xl bg-white">
//                 <div className="max-w-md mx-auto border-t border-gray-200 py-1 px-1">
//                     <div className="flex justify-between items-center p-4">
//                         <div className="flex flex-col">
//                             <span className="text-xl font-bold text-blue-600">{formatPrice(total)} NGN</span>
//                             <span className="text-xs text-gray-500">Total price</span>
//                         </div>



//                         <button
//                             onClick={handlePayNow}
//                             disabled={isProcessing} // Disable button while processing
//                             className={`py-3 px-8 rounded-xl font-semibold text-lg shadow-lg transition duration-200 ${isProcessing
//                                 ? 'bg-gray-400 cursor-not-allowed'
//                                 : 'bg-blue-600 text-white hover:bg-blue-700'
//                                 }`}
//                         >
//                             {isProcessing ? (
//                                 <Loader2 className="w-6 h-6 animate-spin inline-block mr-2" />
//                             ) : (
//                                 'Pay Now'
//                             )}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//         // </div>
//     );
// };
// --- 3. PRODUCT VIEW WRAPPER COMPONENT (Replaces the old default export) ---




const FinalPaymentView = ({ cartItems, onBack, setActiveScreen, shippingDetails, authToken,setCartItems,onBackToMarketplace }) => {
    const ORDER_API_URL = `${API_BASE_URL}/orders`;
    const VERIFY_API_BASE = `${API_BASE_URL}/payments`;

    const [isProcessing, setIsProcessing] = useState(false);
    // NEW State: Stores the data needed to show the Interswitch button
    const [paymentData, setPaymentData] = useState(null);
    const [serverError, setServerError] = useState(null);


    const normalizeNGNumber = (num) => {
  if (!num) return undefined;
  if (num.startsWith('0')) return '+234' + num.slice(1);
  if (num.startsWith('234')) return '+' + num;
  return num; // already +234
};
    const contactEmail = shippingDetails?.email || '';


let contactMobNo = normalizeNGNumber(shippingDetails?.mobile) || '';

    const shippingAddress = shippingDetails
        ? `${shippingDetails.address}, ${shippingDetails.postalCode}, ${shippingDetails.city}, ${shippingDetails.country}`
        : 'N/A';

    const mockMethod = "Standard Shipping - FREE";
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('card');

    const cartCalculations = useMemo(() => {
        const total = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        return { total };
    }, [cartItems]);

    const { total } = cartCalculations;

    // // 1. Interswitch Callback Handler
    // const handleInterswitchCallback = (response) => {
    //     console.log('Interswitch Payment Response:', response);
    //     setPaymentData(null); // Reset to allow retrying order creation if needed

    //     if (response.resp === '00') {
    //         // Payment was successful (ALWAYS VERIFY ON BACKEND IN PRODUCTION)
    //         setActiveScreen('successView', {
    //        orderId: paymentData?.orderId, // Use the server-generated order ID
    //             // Use the client-side calculated total for display, or ensure the response amount is converted back to NGN.
    //             totalAmount: total, // Using client-side total is safer for display until server verification
    //             paymentMethod: 'Interswitch Card', // Descriptive label
    //             // CRITICAL: Use the definitive reference from the payment response
    //             transactionRef: response.retrievalReference,
    //         });
    //     } else {
    //         // Payment failed or was cancelled
    //         alert(`Payment failed or cancelled. Response: ${response.desc}. Please try again.`);
    //         // Re-enable the Pay Now button if they need to retry the entire flow
    //         onBack();
    //         setIsProcessing(false); 
    //     }
    // };


  
        
    const handleRemoveItem = (id) => {
        setCartItems(prevItems => prevItems.filter(item => item.id !== id));
        //   localStorage.removeItem(OFFLINE_CHECKOUT_STATE_KEY);
        //  setActiveScreen('orders')
        // onBackToMarketplace()
    };



    // Check for empty cart
    if (cartItems.length === 0) {
        return (
            // <div className="bg-gray-100 font-inter flex flex-col h-screen w-full">
            // <div className="max-w-md mx-auto w-full bg-white shadow-xl flex flex-col relative h-full">
            <div className="bg-white font-inter flex flex-col h-screen w-full">
                <Header title="Checkout" onBack={onBack} />
                <div className="flex-grow flex flex-col items-center justify-center p-8 text-center">
                    <ShoppingCart name="ShoppingCart" className="w-16 h-16 text-gray-300 mb-4" />
                    <h2 className="text-xl font-semibold text-gray-700 mb-2">Your Cart is Empty</h2>
                    <p className="text-gray-500 mb-6">Start shopping to proceed to checkout.</p>
                    <button
                        onClick={onBackToMarketplace}
                        className="bg-blue-600 text-white py-2 px-6 rounded-xl font-semibold shadow-md hover:bg-blue-700 transition"
                    >
                        Start Shopping
                    </button>
                </div>
            </div>
            // </div>
        );
    }
    

    // 1. Interswitch Callback Handler (FINALIZED WITH SERVER VERIFICATION)
    const handleInterswitchCallback = async (response) => {
        console.log('Interswitch Payment Response:', response);

        // Note: isProcessing is true from the order creation step.
        setPaymentData(null); // Reset payment data to prepare for next payment attempt if needed

        // Check if the client-side response indicates success or a state that requires verification 
        // (e.g., '00' for success, or a pending code like 'Z0')
        if (response.resp === '00') {

            // --- 1. Get Payment ID and Prepare for Verification ---
            const paymentId = paymentData?.paymentId;

            if (!paymentId) {
                setServerError("Verification failed: Missing payment reference from server setup.");
                setIsProcessing(false);
                onBack(); // Go back if we can't verify
                return;
            }

            console.log(`Starting server verification for Payment ID: ${paymentId}`);
            setServerError(null); // Clear any previous errors

            try {
                // --- 2. Call the server verification API ---
                const verifyResponse = await fetch(`${VERIFY_API_BASE}/${paymentId}/verify`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`,
                    },
                });

                const verificationResult = await verifyResponse.json();

                // --- 3. Handle the Server Verification Result ---
                const serverStatus = verificationResult.status;
                const paymentDetails = verificationResult.data?.payment;

                // ✅ SUCCESS CHECK: Use the top-level status field from your API response
                if (verifyResponse.ok && serverStatus === 'SUCCESS') {
                    console.log('Payment verified successfully by server:', verificationResult);

                    // Extract the final, definitive transaction reference
                    const transactionRef = paymentDetails?.reference?.id;

                    // Payment is confirmed! Navigate to success screen.
                    // setActiveScreen('successView', {
                    //     orderId: paymentData.orderId,
                    //     totalAmount: paymentDetails.amount,
                    //     paymentMethod: paymentDetails?.method?.label,
                    //     transactionRef: transactionRef,
                    // });
                    setActiveScreen('successView', {
                        orderId: paymentData.orderId,
                        totalAmount: paymentDetails.amount,
                        // We are passing all the data we need to avoid local calculations/mocks
                        verificationDetails: {
                            amount: paymentDetails.amount, // "2542.00"
                            paymentLabel: paymentDetails.method.label, // "Debit/Credit Card"
                            statusLabel: paymentDetails.status.label, // "Payment Successful"
                            invoiceNumber: paymentDetails.invoice, // "FBN|WEB|..."
                            transactionRef: transactionRef, // "TXN-c29f8350..."
                            transactionDate: paymentDetails.reference.TransactionDate, // "2025-12-14T06:28:07"
                        }
                    });

                } else {
                    // Server verification failed (e.g., status is 'FAILED' or top-level status is not 'SUCCESS')
                    const errorMsg = verificationResult.message || `Payment status: ${serverStatus}. Verification failed.`;
                    console.error('Server verification failed:', errorMsg);
                    alert(`Payment failed: ${errorMsg}. Returning to the previous screen.`);
                    setServerError(errorMsg);
                    onBack(); // Go back on verification failure
                }

            } catch (error) {
                console.error('Network error during verification:', error);
                setServerError('A network error occurred during payment verification. Please contact support.');
                alert('Verification failed due to a network error. Returning to the previous screen.');
                onBack(); // Go back on network error
            }
        } else {
            // Client-side response indicated an outright failure or user cancellation
            alert(`Payment failed or cancelled. Response: ${response.desc}. Returning to previous screen.`);
            onBack(); // Go back on client-side failure/cancellation
        }

        // Final cleanup for processing state
        setIsProcessing(false);
    };
    // 2. Original handlePayNow (Renamed to focus on server interaction)
    const handleCreateServerOrder = async () => {
        if (isProcessing || paymentData) return; // Prevent double submission or re-submission

        if (!cartItems || cartItems.length === 0) {
            alert("Your cart is empty. Please add items before paying.");
            return;
        }



        // Payload to satisfy your API's validation (product ID and quantity)
        const orderItems = cartItems.map(item => ({
            product: item.id,
            quantity: item.quantity,
        }));

        const payload = {
            product: orderItems[0].product,
            quantity: orderItems[0].quantity,
            address: shippingAddress,
            paymentMethod: selectedPaymentMethod,
        };

        console.log("Order Payload:", payload);
        setServerError(null);
        setIsProcessing(true);

        try {
            const response = await fetch(ORDER_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (response.ok) {
                console.log('Server Order created successfully:', result);

                // CRITICAL: Get the data needed for Interswitch
                const orderData = result.data?.order || {};
                const paymentInfo = result.data?.payment || {};
                const paymentRef = paymentInfo.reference || {};


                // --- Store the necessary data for Interswitch from the SERVER RESPONSE ---
                setPaymentData({
                    orderId: orderData.id,
                    // Use the reference provided by the server
                    paymentId: paymentInfo.id,
                    transactionReference: paymentRef.id,
                    amount: String(parseFloat(paymentInfo.amount) * 100), // Amount in Kobo/Cents
                    merchantCode: paymentRef.merchant,
                    payItemId: paymentRef.charge,
                    mode: paymentRef.mode, // Use the mode (TEST/LIVE) from the server
                });
                // Note: isProcessing remains true until payment is finished

            } else {
                console.error('Server Order creation failed:', result);
                setServerError(result.message || 'An unknown error occurred during order setup.');
                setIsProcessing(false); // Stop processing on server failure
            }
        } catch (error) {
            console.error('Network or system error during order creation:', error);
            setServerError('A network error occurred. Please check your connection and try again.');
            setIsProcessing(false); // Stop processing on network failure
        }
    };

    // 3. Interswitch Parameters (Dynamically generated)
    const interswitchParams = paymentData ? {
        merchantCode: paymentData.merchantCode,
        payItemID: paymentData.payItemId,
        customerEmail: contactEmail,
        // customerMobileNo:contactMobNo,
        redirectURL: window.location.origin,
        mode: paymentData.mode,
        text: 'Proceed to Payment Gateway',
        transactionReference: paymentData.transactionReference,
        amount: paymentData.amount, // Already in Kobo/Cents as a string
        callback: handleInterswitchCallback,
    } : null;


    // 4. Dynamic Button Renderer
    const renderActionButton = () => {

        // Show the Interswitch button after successful server order creation
        if (paymentData && interswitchParams) {
            return (
                <div className="w-full">
                    <InterswitchPay
                        {...interswitchParams}
                        // Style the Interswitch button to match your original blue button
                        style={{
                            width: '100%',
                            height: '48px',
                            border: 'none',
                            color: '#fff',
                            backgroundColor: '#2563EB', // Blue-600
                            borderRadius: '12px',
                            fontWeight: '600',
                            fontSize: '14px',
                            padding: '5px 12px',
                            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.06)',
                            cursor: 'pointer',
                        }}
                    />
                </div>
            );
        }

        // Show the initial 'Pay Now' button
        return (
            <button
                onClick={handleCreateServerOrder}
                disabled={isProcessing}
                className={`py-3 px-8 rounded-xl font-semibold text-lg shadow-lg transition duration-200 ${isProcessing
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-blue-600 text-white hover:bg-blue-700'
                    }`}
            >
                {isProcessing ? (
                    <Loader2 className="w-6 h-6 animate-spin inline-block mr-2" />
                ) : (
                    'Pay Now'
                )}
            </button>
        );
    };


    return (
        <div className="bg-white font-inter flex flex-col h-full w-full">
            <Header title="Checkout" onBack={onBack} />

            <main className="h-full overflow-y-auto p-4 pt-6 pb-24">
                <h2 className="text-xl font-bold text-gray-900 mb-6 text-center">Your cart items</h2>
                {/* Back to shopping button */}
                {/* <button
                    onClick={() => console.log('Back to shopping')}
                    className="text-blue-600 font-semibold text-sm block mx-auto mb-6 hover:underline mt-[-10px]"
                >
                    Back to shopping
                </button> */}
                {/* Product and Price Header */}
                <div className="flex justify-between border-b border-gray-300 pb-2 mb-4">
                    <span className="text-xs uppercase font-bold text-gray-500 w-1/2">Product</span>
                    <span className="text-xs uppercase font-bold text-gray-500 w-1/2 text-right">Price</span>
                </div>
                {/* Cart Item Display */}
                {cartItems.map(item => (
                    <div key={item.id} className="flex justify-between items-start py-3 border-b border-gray-100">
                        {/* Item Details */}
                        <div className="flex items-start space-x-3 w-1/2">
                            <img
                                src={item.images && item.images.length > 0 ? item.images[0].url : ''}
                                alt={item.name}
                                className="w-16 h-12 object-cover rounded-lg flex-shrink-0"
                            />
                            <div className="flex-grow">
                                <p className="text-sm text-gray-900 font-medium leading-tight">{item.name}</p>
                                <button className="text-blue-600 font-medium text-xs hover:underline" onClick={()=>handleRemoveItem(item.id)}>Remove</button>
                            </div>
                        </div>
                        {/* Quantity and Price */}
                        <div className="flex flex-col items-end w-1/2 space-y-2">
                            <p className="text-sm font-bold text-gray-900">{formatPrice(item.price)} NGN</p>
                            <div className="flex items-center border border-gray-300 rounded-md">
                                <span className="px-2 py-1 text-sm font-medium text-gray-700">{item.quantity}</span>
                                <button disabled className="px-1 py-1 text-gray-300 rounded-r-md"><Plus className="w-3 h-3" /></button>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Contact, Ship To, and Method Summary Block */}
                <div className="mt-8 p-4 border border-gray-300 rounded-xl space-y-3">
                    {/* ... (Summary Rows) ... */}
                    <div className="flex justify-between items-start">
                        <div className="text-sm flex-grow pr-4">
                            <span className="text-gray-500 inline-block w-16">Contact</span>
                            <span className="text-gray-700 font-medium">{contactEmail}</span>
                        </div>
                        {/* <button className="text-blue-600 font-medium text-sm flex-shrink-0">Edit</button> */}
                    </div>
                    <div className="flex justify-between items-start">
                        <div className="text-sm flex-grow pr-4">
                            <span className="text-gray-500 inline-block w-16">Ship to</span>
                            <span className="text-gray-700 font-medium max-w-xs block sm:inline-block pl-16 -mt-4 sm:pl-0 sm:mt-0">{shippingAddress}</span>
                        </div>
                        {/* <button className="text-blue-600 font-medium text-sm flex-shrink-0">Edit</button> */}
                    </div>
                    <div className="flex justify-between items-start border-t border-gray-200 pt-3">
                        <div className="text-sm flex-grow pr-4">
                            <span className="text-gray-500 inline-block w-16">Method</span>
                            <span className="text-gray-700 font-medium">{mockMethod}</span>
                        </div>
                        {/* <button className="text-blue-600 font-medium text-sm flex-shrink-0">Edit</button> */}
                    </div>
                </div>

                {/* Choose Payment Method Section */}
                <div className="mt-8 p-4 bg-blue-50 rounded-xl border border-blue-200">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">Choose Payment Method</h3>
                    <div className="flex space-x-8">
                        {/* Debit/Credit Card */}
                        <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                                type="radio"
                                name="payment"
                                value="card"
                                checked={selectedPaymentMethod === 'card'}
                                onChange={() => setSelectedPaymentMethod('card')}
                                className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                            />
                            <span className="text-sm text-gray-700">💳 Debit/Credit Card (Interswitch)</span>
                        </label>

                        {/* Net Banking */}
                        <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                                type="radio"
                                name="payment"
                                value="net_banking"
                                checked={selectedPaymentMethod === 'net_banking'}
                                onChange={() => setSelectedPaymentMethod('net_banking')}
                                className="w-4 h-4 text-gray-300 border-gray-300 focus:ring-gray-500"
                            />
                            <span className="text-sm text-gray-700">Net Banking</span>
                        </label>
                    </div>
                </div>

                {/* Server Error Message */}
                {serverError && (
                    <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                        <p className="font-medium">Error:</p>
                        <p className="text-sm">{serverError}</p>
                    </div>
                )}
            </main>

            {/* Fixed Footer Action (Total price and dynamic button) */}
            <div className="fixed bottom-0 inset-x-0 z-30 shadow-2xl bg-white">
                <div className="max-w-md mx-auto border-t border-gray-200 py-1 px-1">
                    <div className="flex justify-between items-center p-4">
                        {/* Total Price Display */}
                        <div className="flex flex-col">
                            <span className="text-md font-bold text-blue-600">{formatPrice(total)} NGN</span>
                            <span className="text-xs text-gray-500">Total price</span>
                        </div>

                        {/* Dynamic Payment Button Area */}
                        <div className=" flex-shrink-0">
                            {renderActionButton()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// const ProductViewWrapper = ({ onBack, setActiveScreen }) => {
//     // State to manage the internal view: 'product' or 'checkout'
//     const [view, setView] = useState('product'); 

//     console.log(view,'check view',setActiveScreen,onBack)

//     // State to manage cart items (initialize with one product for demonstration)
//     const [cartItems, setCartItems] = useState([{ ...product, quantity: 1 }]); 

//     const handleAddToCart = (productToAdd) => {
//         setCartItems(prevItems => {
//             const existingItem = prevItems.find(item => item.id === productToAdd.id);
//             if (existingItem) {
//                 return prevItems.map(item => 
//                     item.id === productToAdd.id ? { ...item, quantity: item.quantity + 1 } : item
//                 );
//             } else {
//                 return [...prevItems, { ...productToAdd, quantity: 1 }];
//             }
//         });
//     };

//     // This function translates the internal view change to the DashApp's setActiveScreen
//     const handleInternalViewChange = (newView) => {
//         if (newView === 'checkoutView') {
//             // If internal view is checkout, update the DashApp state (to hide navbar)
//             setActiveScreen('checkoutView');
//             setView('checkout'); 
//         } else if (newView === 'orders') {
//             // If going back to the marketplace, update the DashApp state
//             setActiveScreen('orders');
//         } else if (newView === 'marketplaceProductView') {
//             // If going back from checkout to product detail, reset internal view and DashApp state
//             setActiveScreen('marketplaceProductView');
//             setView('product');
//         }
//     }

//     // Render the appropriate component based on the current view state
//     let CurrentScreen;
//     if (view === 'checkout') {
//         CurrentScreen = <CheckoutView 
//                             cartItems={cartItems} 
//                             setCartItems={setCartItems}
//                             onBack={() => handleInternalViewChange('marketplaceProductView')} // Back to product detail
//                             setActiveScreen={handleInternalViewChange}
//                         />;
//     } else {
//         CurrentScreen = <ProductViews 
//                             onAddToCart={handleAddToCart}
//                             onBack={onBack} // Uses the onBack from DashApp to go to 'orders'
//                             setActiveScreen={handleInternalViewChange}
//                         />;
//     }

//     return (
//         <div className="min-h-screen">
//             {/* The actual screen content */}
//             {CurrentScreen}
//         </div>
//     );
// };
// --- 6. ORDER SUCCESS VIEW COMPONENT ---

// const OrderSuccessView = ({ totalAmount }) => {
//     // Mock data based on the provided image (Marketplace (catalog & product detail) (4).png)
//     const mockDetails = {
//         invoiceNumber: "INV567489240UI",
//         paymentMethod: "Debit/Credit Card",
//         date: "24 February 2023",
//         time: "09:41 AM",
//         status: "Successful",
//         // Total amount is passed as a prop from the FinalPaymentView flow
//     };

//     // Helper to format the total amount
//     const displayAmount = totalAmount ? formatPrice(totalAmount) : '0.00'; 

//     return (
//         <div className="bg-gray-100 font-inter flex flex-col h-full w-full">
//             <div className="max-w-md mx-auto w-full bg-white shadow-xl flex flex-col items-center p-6 rounded-xl relative flex-grow">

//                 {/* Fixed Back Arrow (to maintain visual context, though usually disabled on success) */}
//                 <header className="flex w-full items-center mb-6">
//                     <button 
//                         className="text-gray-600 hover:text-blue-500 transition p-1 -ml-1" 
//                         onClick={() => console.log('Simulate exit to Orders list')}
//                         aria-label="Go back"
//                     >
//                         <ChevronLeft className="w-6 h-6" />
//                     </button>
//                     <h1 className="flex-grow text-center text-lg font-semibold text-gray-800 mr-6">Checkout</h1> 
//                 </header>

//                 {/* Success Content */}
//                 <div className="flex flex-col items-center text-center w-full space-y-6">

//                     {/* Checkmark Icon */}
//                     <div className="p-4 bg-blue-600 rounded-full shadow-lg">
//                         <CheckCircle className="w-12 h-12 text-white" />
//                     </div>

//                     <h2 className="text-xl font-bold text-gray-900">Your payment was successful!</h2>

//                     {/* Invoice Details Grid */}
//                     <div className="grid grid-cols-2 gap-y-4 gap-x-4 w-full p-4 border border-gray-200 rounded-xl text-left">

//                         <div className="text-sm text-gray-500">Invoice Number</div>
//                         <div className="text-sm font-semibold text-gray-800 text-right">{mockDetails.invoiceNumber}</div>

//                         <div className="text-sm text-gray-500">Payment Method</div>
//                         <div className="text-sm font-semibold text-gray-800 text-right">{mockDetails.paymentMethod}</div>

//                         <div className="text-sm text-gray-500">Date</div>
//                         <div className="text-sm font-semibold text-gray-800 text-right">{mockDetails.date}</div>

//                         <div className="text-sm text-gray-500">Time</div>
//                         <div className="text-sm font-semibold text-gray-800 text-right">{mockDetails.time}</div>

//                         <div className="text-sm text-gray-500 font-bold">Amount Paid</div>
//                         <div className="text-lg font-extrabold text-blue-600 text-right">{displayAmount} NGN</div>

//                         <div className="text-sm text-gray-500">Status</div>
//                         <div className="text-sm font-semibold text-green-600 text-right">{mockDetails.status}</div>

//                     </div>

//                     {/* Action Buttons */}
//                     <div className="w-full space-y-3 pt-4">
//                         <button 
//                             onClick={() => console.log('Download Invoice')}
//                             className="w-full border border-blue-600 text-blue-600 py-3 rounded-xl font-semibold text-lg hover:bg-blue-50 transition duration-200 flex items-center justify-center space-x-2"
//                         >
//                             <Download className="w-5 h-5" />
//                             <span>Download Invoice</span>
//                         </button>
//                         <button 
//                             onClick={() => console.log('Track Shipment')}
//                             className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-lg shadow-lg hover:bg-blue-700 transition duration-200 flex items-center justify-center space-x-2"
//                         >
//                             <MapPin className="w-5 h-5" />
//                             <span>Track your shipment</span>
//                         </button>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };



const OrderSuccessView = ({ orderId, totalAmount, paymentMethod, setActiveScreen, onBack, onBackToMarketplace, verificationDetails }) => {
    //                                                                                                     ^ NEW PROP

    // Utility function to safely format the date string
    const formatTransactionDate = (isoString) => {
        if (!isoString) return { date: 'N/A', time: 'N/A' };
        try {
            const dateObj = new Date(isoString);

            // Date format: e.g., December 14, 2025
            const date = dateObj.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });

            // Time format: e.g., 06:28 AM
            const time = dateObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });

            return { date, time };
        } catch (e) {
            console.error("Failed to parse transaction date:", e);
            return { date: 'N/A', time: 'N/A' };
        }
    };

    // --- 🚨 Use VERIFIED DATA ---
    // Fallback to old props if verificationDetails is missing (e.g., in testing)
    const paymentData = verificationDetails || {};

    console.log(paymentData,'test data alert')

    const displayAmount = paymentData.amount || totalAmount;
    const displayOrderId = orderId || "N/A";
    const displayPaymentMethod = paymentData.paymentLabel || 'N/A';
    const displayInvoiceNumber = paymentData.invoiceNumber || displayOrderId;
    const displayStatus = paymentData.statusLabel === "Payment Successful" ?'Successful':'Failed';
    const transactionDateTime = formatTransactionDate(paymentData.transactionDate);
    const displayTransactionRef = paymentData.transactionRef || 'N/A'; // Adding the Transaction Ref

    // Data structured to fit the 2x2 stacked layout
    const transactionDetails = [
        {
            labelLeft: "Transaction ID",
            valueLeft: displayTransactionRef, // Use the definitive TXN ID
            labelRight: "Payment Method",
            valueRight: displayPaymentMethod
        },
        {
            labelLeft: "Invoice Number",
            valueLeft: displayInvoiceNumber, // Use the actual invoice number
            labelRight: "Date",
            valueRight: transactionDateTime.date
        },
        // {
        //     labelLeft: "Time",
        //     valueLeft: transactionDateTime.time,
        //     labelRight: "",
        //     valueRight: ""
        // }
    ];

    return (
        <div className="bg-white font-inter flex flex-col h-full w-full">

            {/* HEADER */}
            <Header title="Order Receipt" />

            {/* MAIN CARD */}
            <div className="w-full px-4 flex justify-center flex-grow">
                <div className="w-full max-w-lg bg-white rounded-3xl shadow-xl p-6 pb-8 h-fit mt-4 md:mt-10">

                    {/* SUCCESS ICON */}
                    <div className="flex justify-center mt-2 mb-6">
                        <div className="bg-blue-600 rounded-full p-4 ring-8 ring-blue-500/20 shadow-lg">
                            <Check className="w-10 h-10 text-white" />
                        </div>
                    </div>

                    {/* TITLE */}
                    <h2 className="text-center text-xl font-bold text-gray-900 mb-6">
                        Your payment was successful!
                    </h2>

                    {/* DETAILS SECTION */}
                    <div className="space-y-6 pt-4">

                        {/* TRANSACTION INFO GRID (TXN ID, Invoice, Payment, Date, Time) */}
                        {transactionDetails.map((row, index) => (
                            <div key={index} className="grid grid-cols-2 gap-x-4 gap-y-1">
                                {/* Left Item */}
                                <div>
                                    <div className="text-gray-500 text-sm">{row.labelLeft}</div>
                                    <div className="font-semibold text-gray-900 text-base break-all">{row.valueLeft}</div>
                                </div>
                                {/* Right Item */}
                                <div>
                                    <div className="text-gray-500 text-sm text-right">{row.labelRight}</div>
                                    <div className="font-semibold text-gray-900 text-base text-right break-all">{row.valueRight}</div>
                                </div>
                            </div>
                        ))}

                        {/* FINAL SUMMARY (Amount Paid and Status) - Separated by dashed line */}
                        <div className="pt-6 border-t border-dashed border-gray-200 grid grid-cols-2 gap-x-4">
                            {/* Amount Paid Label */}
                            <div className='text-gray-500 text-sm'>Amount Paid</div>
                            {/* Status Label */}
                            <div className='text-gray-500 text-sm text-right'>Status</div>

                            {/* Amount Paid Value */}
                            <div>
                                <div className="text-lg font-extrabold text-gray-900">
                                    {displayAmount} {paymentData.currencyCode || 'NGN'}
                                </div>
                            </div>
                            {/* Status Value */}
                            <div className='flex items-end justify-end'>
                                <div className="font-extrabold text-lg text-green-600">
                                    {displayStatus}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Fixed Footer for Buttons */}
            <div className="fixed bottom-0 inset-x-0 z-30 shadow-2xl bg-white">
                <div className="max-w-md mx-auto border-t border-gray-200 py-3 px-3">
                    <div className="w-full space-y-3">

                        {/* DOWNLOAD BUTTON */}
                        <button
                            onClick={() => console.log("Download Invoice")}
                            className="w-full bg-blue-50 hover:bg-blue-100 transition py-3 rounded-xl flex items-center justify-center space-x-2 text-blue-600 font-semibold text-base"
                        >
                            <Download className="w-5 h-5" />
                            <span>Download Invoice</span>
                        </button>

                        {/* BACK TO MARKETPLACE BUTTON */}
                        <button
                            onClick={onBackToMarketplace}
                            className="w-full bg-blue-600 hover:bg-blue-700 transition py-3 rounded-xl text-white font-semibold text-base"
                        >
                            Go to Marketplace
                        </button>

                    </div>
                </div>
            </div>

            {/* Filler space at the bottom for mobile viewport centering */}
            <div className="h-24"></div>
        </div>
    );
};
const OFFLINE_CHECKOUT_STATE_KEY = 'checkout_state_backup';

const ProductViewWrapper = ({ onBack, setActiveScreen, productId, authToken ,userSession}) => {
  
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    const getInitialState = (currentProductId) => {
        const storedState = JSON.parse(localStorage.getItem(OFFLINE_CHECKOUT_STATE_KEY));

        // Only restore if state exists AND it belongs to the current product/session
        if (storedState && storedState.productId === currentProductId) {
            console.log("Restoring internal checkout state:", storedState.view, storedState.checkoutStep);
            return {
                view: storedState.view,
                checkoutStep: storedState.checkoutStep,
                cartItems: storedState.cartItems,
                finaldetails: storedState.finaldetails,
                shippingDetails: storedState.shippingDetails,
            };
        }

        // Default initial state (start at product view)
        return {
            view: 'product',
            checkoutStep: 'cart',
            cartItems: [],
            finaldetails: {},
            shippingDetails: null,
        };
    };

    const initialState = getInitialState(productId);

    const [view, setView] = useState(initialState.view);
    const [checkoutStep, setCheckoutStep] = useState(initialState.checkoutStep);
    const [cartItems, setCartItems] = useState(initialState.cartItems);
    const [finaldetails, setFinaldetails] = useState(initialState.finaldetails);
    const [shippingDetails, setShippingDetails] = useState(initialState.shippingDetails);

    console.log(isOnline, 'test online')

    const [storedProductId, setStoredProductId] = useState(productId);


    console.log(storedProductId, 'checked if offline in main')


    // --- 1. State Initialization (Reads from Local Storage) ---
    // --- 2. Effect for Network Status and State Persistence ---
   // ... (rest of ProductViewWrapper code before useEffect) ...

// --- 2. Effect for Network Status and State Persistence ---
useEffect(() => {
    
    const saveStateToLocalStorage = () => {
        // Only save if the user is actively in the checkout flow
        // if (view === 'checkout') {
        
        //     if (checkoutStep === 'success' && finaldetails && Object.keys(finaldetails).length > 0) {
        //          console.log("Internal checkout state not saved: SUCCESS state should not be persisted.");
        //          return; 
        //     }
            
        //     // If we reach here, the checkout is in progress (cart, address, etc.) and should be saved.
        //     const stateToSave = {
        //         view,
        //         checkoutStep,
        //         cartItems,
        //         finaldetails,
        //         shippingDetails,
        //         productId,
        //     };
        //     localStorage.setItem(OFFLINE_CHECKOUT_STATE_KEY, JSON.stringify(stateToSave));
        //     console.log("Internal checkout state saved:", checkoutStep);
        // }
        if (view === 'checkout' && cartItems.length > 0) {
            
            // Don't save if we finished successfully
            if (checkoutStep === 'success' && finaldetails && Object.keys(finaldetails).length > 0) {
                 console.log("Internal checkout state not saved: SUCCESS state should not be persisted.");
                 return; 
            }
            
            const stateToSave = {
                view,
                checkoutStep,
                cartItems,
                finaldetails,
                shippingDetails,
                productId,
            };
            localStorage.setItem(OFFLINE_CHECKOUT_STATE_KEY, JSON.stringify(stateToSave));
            console.log("Valid checkout state saved.");
        } 
        // 2. NEW LOGIC: If we are leaving and the cart is empty, wipe the storage
        else if (cartItems.length === 0) {
            localStorage.removeItem(OFFLINE_CHECKOUT_STATE_KEY);
            console.log("Empty cart detected on unmount - storage cleared.");
        }
    }
    

    // Save the state whenever the component unmounts (cleanup phase)
    return () => {
        // The cleanup runs when the component unmounts (e.g., when going to 'orders')
        saveStateToLocalStorage();
    };

}, [view, checkoutStep, cartItems, finaldetails, shippingDetails, productId]); // Dependency array remains the same

// ... (rest of ProductViewWrapper code) ...

    const handleAddToCart = (productToAdd) => {
        setCartItems(prevItems => {
            const existingItem = prevItems.find(item => item.id === productToAdd.id);
            if (existingItem) {
                return prevItems.map(item =>
                    item.id === productToAdd.id ? { ...item, quantity: item.quantity + 1 } : item
                );
            } else {
                return [...prevItems, { ...productToAdd, quantity: 1 }];
            }
        });
    };



    // }
    const handleInternalViewChange = (newView, payload = {}) => {

        console.log(payload, 'test payoad')
        if (newView === 'checkoutView') {
            // Enter the checkout flow from ProductViews

            // if (payload.product) { 
            //     // This branch handles the "Buy Now" click from the MarketplaceCard
            //     handleAddToCart(payload.product); // **1. Add the specific product to the cart**
            // } else if (productId) {
            //      // Fallback for ProductView if it's not direct.
            //      // You might need an effect to fetch this single product detail here.
            //      console.warn("Direct checkout initiated without full product details in payload. Cart might be empty.");
            // }
            setActiveScreen('checkoutView');
            setView('checkout');
            setCheckoutStep('cart');
            // setproductid(payload)
        } else if (newView === 'addressView') {
            // Move from cart summary to address form
            setCheckoutStep('address');
        } else if (newView === 'confirmationView') {
            // NEW LOGIC: Move from address form to payment confirmation screen
            setCheckoutStep('confirmation');
        }
        else if (newView === 'paymentView') { // <--- NEW LOGIC
            setCheckoutStep('payment');
        }
        else if (newView === 'successView') { // <--- NEW LOGIC
            localStorage.removeItem(OFFLINE_CHECKOUT_STATE_KEY);
            setFinaldetails(payload); // Store the amount
            setCheckoutStep('success');
        }
        else if (newView === 'orders') {
            // Going back to the marketplace

            setActiveScreen('orders');
        } else if (newView === 'marketplaceProductView') {
            // Going back from checkout to product detail
            setActiveScreen('marketplaceProductView', payload);
            setView('product');
        }
    }

    const handleAddressSubmit = (data) => {
        setShippingDetails(data);
        handleInternalViewChange('confirmationView');
    };



    const handleBackToMarketplace = () => {
    localStorage.removeItem(OFFLINE_CHECKOUT_STATE_KEY);
    
    console.log(OFFLINE_CHECKOUT_STATE_KEY)// <--- ENSURE THIS IS FIRST
    
    // 2. Clear all internal state variables
    setCartItems([]); 
    setShippingDetails(null); 
    setFinaldetails({}); 
    
    // 3. Reset the internal view state to the beginning
    setView('product'); 
    setCheckoutStep('cart');
    
    // 4. Navigate the application back to the main marketplace/orders view
    setActiveScreen('orders'); 
    };

     // --- Android back handling inside product/checkout flow ---
  useProductBackHandler(view, checkoutStep, handleInternalViewChange);

    // Render the appropriate component based on the current view state
    let CurrentScreen;
    if (!isOnline) {
        CurrentScreen = (
            <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center bg-white">
                <WifiOff className="w-12 h-12 text-red-500 mb-4" />
                <p className="text-xl font-bold text-gray-800 mb-2">No Internet Connection</p>
                <p className="text-gray-600 mb-4">Please connect to the internet to continue.</p>
                <button
                    onClick={() => setActiveScreen("home")}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg"
                >
                    Go to Dashboard
                </button>
            </div>
        );
    }



    else if (view === 'product') {
        CurrentScreen = <ProductViews
            onAddToCart={handleAddToCart}
            onBack={onBack}
            setActiveScreen={handleInternalViewChange}
            productId={storedProductId}
            authToken={authToken}

        />;
    }
    else if (view === 'checkout') {

        // if (checkoutStep === 'success') {
        //     CurrentScreen = <OrderSuccessView
        //         orderId={finaldetails.orderId}
        //         totalAmount={finaldetails.totalAmount}
        //         paymentMethod={finaldetails.paymentMethod}
        //         setActiveScreen={setActiveScreen}
        //         // onBack={onBack}
        //         onBackToMarketplace={handleBackToMarketplace}
        //     />;
        // }

        if (checkoutStep === 'success' && finaldetails && Object.keys(finaldetails).length > 0) {
        CurrentScreen = <OrderSuccessView
            orderId={finaldetails.orderId}
            totalAmount={finaldetails.totalAmount}
            paymentMethod={finaldetails.paymentMethod}
            verificationDetails={finaldetails.verificationDetails} // Ensure verification details are passed
            setActiveScreen={setActiveScreen}
            onBack={onBack}
            onBackToMarketplace={handleBackToMarketplace}
        />;
    }
        // 4. RENDER FINAL PAYMENT VIEW
        else if (checkoutStep === 'payment') {
            CurrentScreen = <FinalPaymentView
                cartItems={cartItems}
                onBack={() => setCheckoutStep('confirmation')}
                setActiveScreen={handleInternalViewChange} // Used by Pay Now to transition to 'successView'
                shippingDetails={shippingDetails}
                authToken={authToken}
                onBackToMarketplace={handleBackToMarketplace}
                  setCartItems={setCartItems}
            />;
        }
        // 3. RENDER CONFIRMATION VIEW
        // else if (checkoutStep === 'confirmation') {
        //     CurrentScreen = <PaymentConfirmationView
        //         cartItems={cartItems}
        //         // Back button goes from Confirmation back to Address Form
        //         onBack={() => setCheckoutStep('address')}
        //         onGoToNextStep={handleInternalViewChange} // Used to transition to 'paymentView'
        //     />;
        // }
        else if (checkoutStep === 'confirmation') {
            // 💡 PASS SHIPPING DETAILS TO CONFIRMATION VIEW
            CurrentScreen = <PaymentConfirmationView
                cartItems={cartItems}
                shippingDetails={shippingDetails} // <-- PASS DATA HERE
                onBack={() => setCheckoutStep('address')}
                onGoToNextStep={handleInternalViewChange}
                 onBackToMarketplace={handleBackToMarketplace}
                  setCartItems={setCartItems}
            />;
        }
        // else if (checkoutStep === 'address') {
        //     // 2. RENDER ADDRESS FORM VIEW
        //     CurrentScreen = <AddressDetailsView
        //         // Back button goes from Address Form back to Cart Summary
        //         onBack={() => setCheckoutStep('cart')}
        //         setActiveScreen={handleInternalViewChange} // Used to transition to 'confirmationView'
        //     />;
        // } 
        else if (checkoutStep === 'address') {
            CurrentScreen = <AddressDetailsView
                // Back button goes from Address Form back to Cart Summary
                onBack={() => setCheckoutStep('cart')}
                // 💡 PASS NEW SUBMIT HANDLER
                onContinue={handleAddressSubmit}
                // 💡 PASS EXISTING DATA for editing/pre-fill
                initialData={shippingDetails}
                 userSession={userSession}
            />;
        }
        else { // checkoutStep === 'cart'
            // 1. RENDER CART SUMMARY VIEW
            CurrentScreen = <CheckoutView
                cartItems={cartItems}
                setCartItems={setCartItems}
                onBack={() => handleInternalViewChange('marketplaceProductView')}
                setActiveScreen={handleInternalViewChange} // Used by Pay Now to transition to 'addressView'
                productId={storedProductId}
                onBackToMarketplace={handleBackToMarketplace}
            />;
        }
    }



    return (
        <div className="min-h-screen">
            {CurrentScreen}
        </div>
    );
};

export default ProductViewWrapper;
